/* Do not change, this code is generated from Golang structs */


export enum WorkerJobType {
    none = 0,
    test = 1,
}
export enum AutoCoderImportType {
    themeai = "themeai",
    manual = "manual",
}
export enum DataSourceType {
    carbon = "carbon",
    apify = "apify",
}
export enum DataImportStatus {
    pending = "pending",
    importing = "importing",
    ready = "ready",
    failed = "failed",
    loading = "loading",
    scraping = "scraping",
}
export enum CodingStatus {
    pending = "pending",
    processing = "processing",
    completed = "completed",
    failed = "failed",
}
export enum PipelineMode {
    normal = "normal",
    framework = "framework",
}
export enum PipelineLifecycle {
    active = "active",
    paused = "paused",
    archived = "archived",
    one_shot = "one_shot",
}
export enum MultiTableAnalysisState {
    pending = "pending",
    running = "running",
    completed = "completed",
    failed = "failed",
}
export enum MultiTableAnalysisItemState {
    pending = "pending",
    running = "running",
    completed = "completed",
    failed = "failed",
}
export enum ConfigType {
    global = 0,
    customer = 1,
    job = 2,
    folder = 3,
    table = 4,
}
export enum ConfigFieldType {
    string = "string",
    enum = "enum",
    jsonarray = "jsonarray",
    bool = "bool",
    json = "json",
}
export enum ConfigFieldMergeStrategy {
    override = "override",
    merge = "merge",
}
export interface WorkerJob {
    id: number;
    type: WorkerJobType;
    args: any;
    result: any;
    error: string;
}
export interface OpenJobRequest {
    customer_name: string;
    job_name: string;
    var_tree_name: string;
}
export interface MultiTableConfigTable {
    displayName: string;
    folderPath: string;
    filename: string;
    job?: string;
}
export interface MultiTableConfig {
    name: string;
    description: string;
    tables: MultiTableConfigTable[];
    global_filter: string;
}
export interface MultiTable {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    job: string;
    name: string;
    user: string;
    dashboard_id?: string;
    config?: MultiTableConfig;
}


export interface Time {

}
export interface AutoCoderFrameworkMatch {
    root_match: AutoCoderVariableMatch;
    matching_text: string;
    looped_matches: AutoCoderVariableMatch[];
}
export interface AutoCoderRecordData {
    interview_id: string;
    source_text: string;
    commenter_username?: string;
    commenter_display_name?: string;
    matches: AutoCoderFrameworkMatch[];
    suggestions: AutoCoderFrameworkSuggestion[];
    content_filtered?: boolean;
    failure_reason?: string;
}
export interface AutoCoderPipelineRecord {
    id: string;
    auto_coder_pipeline_id: string;
    interview_id: string;
    customer: string;
    job: string;
    dedup_key: string;
    state: string;
    error: string;
    data?: AutoCoderRecordData;
    batch_id?: string;
    attributed_email: string;
    source_date?: Time;
    entity_id?: string;
    import_batch_id?: string;
    metadata?: {[key: string]: string};
    /** The record's own Sprinklr campaign, or the sentinels `unknown` / `none`.
     *  The Go type has always sent this (`json:"campaignId"`); the mirror simply
     *  never declared it, so every consumer was blind to the one field that
     *  decides which Sky department a comment belongs to. */
    campaignId?: string;
    /** Why this record can never be coded, or '' if it can. A record carrying a
     *  reason is a real record — imported, campaign-stamped, filterable — that
     *  simply never enters a batch and therefore never reaches a chart. The
     *  vocabulary is `no_text` and `deleted_at_source` (the platform no longer returns the comment). */
    notCodeableReason?: string;
}

/** Which comments are in a product's numbers, and which are not.
 *
 *  🔴 THERE IS NO TOTAL, DELIBERATELY. A fourth population — records holding no
 *  coding row and stating no reason — is unreported because we cannot say why
 *  they were never sent, so `coded + notCodeable + failed` does NOT equal what
 *  was imported and must never be presented as though it did. Each figure
 *  stands on its own terms. */
export interface UncodedDisclosure {
    coded: number;
    /** We hold the comment; there was nothing in it to analyse. */
    notCodeable: UncodedReason[];
    /** We tried to analyse it and could not. Kept SEPARATE from notCodeable:
     *  the two vocabularies are disjoint and say different things. */
    failed: UncodedReason[];
}
export interface UncodedReason {
    reason: string;
    count: number;
    /** Decomposes `count` by the platform the comment came from, biggest first.
     *  Its counts sum EXACTLY to `count` — the breakdown is counted in the same
     *  scope as the line it explains, so parts can never exceed their whole.
     *  Absent when the server has nothing to break down. */
    platforms?: UncodedPlatform[];
}
/** One platform's share of an exclusion category. An empty `platform` means the
 *  comment carries no platform in its metadata; it is reported rather than
 *  dropped, or the breakdown would fall short of the line it decomposes. */
export interface UncodedPlatform {
    platform: string;
    count: number;
}
export interface AutoCoderImportBatch {
    id: string;
    pipelineId: string;
    customer: string;
    job: string;
    channel: string;
    source: string;
    requestedAt: Time;
    requestedBy: string;
    query?: any;
    windowStart?: Time;
    windowEnd?: Time;
    pages: number;
    fetched: number;
    mapped: number;
    new: number;
    duplicates: number;
    parseSkipped: number;
    truncated: boolean;
    error: string;
    finalizedAt?: Time;
    createdAt: Time;
    status: string;
    driver: string;
    target: string;
    entityId?: string;
    args?: any;
    onComplete?: string;
    attributes?: any;
    parentId?: string;
    attempts: number;
    nextAttemptAt?: Time;
    startedAt?: Time;
    updatedAt: Time;
    units: number;
    costUsd: number;
}
export interface ImportBatchTabCounts {
    inProgress: number;
    scheduled: number;
    done: number;
    failed: number;
}
export interface AutoCoderImportBatchList {
    batches: AutoCoderImportBatch[];
    total: number;
    limit: number;
    offset: number;
    counts?: ImportBatchTabCounts;
}
export interface AutoCoderImportBatchRecords {
    batch?: AutoCoderImportBatch;
    records: AutoCoderPipelineRecord[];
    total: number;
    limit: number;
    offset: number;
}
export interface AutoCoderRecordsQuery {
    importBatchId?: string;
    entityId?: string;
    pipelineId?: string;
    codingBatchId?: string;
    state?: string;
    limit: number;
    offset: number;
}
export interface AutoCoderRecordCodingView {
    pipeline_id: string;
    pipeline_name: string;
    coding_batch_id?: string;
    state: string;
    error: string;
    result?: AutoCoderFrameworkMatch[];
    attributed_email: string;
    completed_at?: Time;
}
export interface AutoCoderRecordWithCodings extends AutoCoderPipelineRecord {
    codings: AutoCoderRecordCodingView[];
}
// POST /autocoder/:customer/:job/records/query — hand-maintained, the envelope
// lives in goapi/pkg/server/autocoder_records.go (a server type, so it has no
// generator registration). Its limit/offset are OPTIONAL on the way out and
// echoed CLAMPED on the way back: absent limit means the server's default of
// 50, and an explicit 0 is rejected with a 400.
export interface RecordsQueryRequest {
    importBatchId?: string;
    entityId?: string;
    pipelineId?: string;
    codingBatchId?: string;
    state?: string;
    limit?: number;
    offset?: number;
}
export interface RecordsQueryResponse {
    records: AutoCoderRecordWithCodings[];
    total: number;
    limit: number;
    offset: number;
}
export interface VariableNames {
    base_name: string;
    freetext_suffix?: string;
    themes_suffix?: string;
    sentiment_suffix?: string;
    emotion_suffix?: string;
}
export interface PromptSettings {
    batch_size: number;
    include_explanations: boolean;
    combined_mode: boolean;
    max_retries: number;
    model_version: string;
    reasoning_effort?: string;
}
export interface AutoCoderVariableMatch {
    name: string;
    code: string;
    explanation: string;
}
export interface AutoCoderFrameworkSuggestion {
    match: AutoCoderVariableMatch;
    matching_text: string;
}
export interface AutoCoderVariable {
    name: string;
    codes: AutoCoderCode[];
}
export interface AutoCoderFramework {
    name: string;
    description?: string;
    main_variable: AutoCoderVariable;
    suggestions: AutoCoderCode[];
    looped_variables: AutoCoderVariable[];
    library_id?: string;
    library_version?: number;
}
export interface FunctionCall {
    name?: string;
    arguments?: string;
}
export interface ToolCall {
    index?: number;
    id?: string;
    type: string;
    function: FunctionCall;
}
export interface ChatMessage {
    role: string;
    content: string;
    tool_calls?: ToolCall[];
}
export interface AutoCoderCode {
    code: string;
    text: string;
    description?: string;
}
export interface ThemeAIEngineConfig {
    themes: AutoCoderCode[];
    suggestions: AutoCoderCode[];
    messages: ChatMessage[];
    batch_size: number;
    prompt: string;
}
export interface FrameworkEngineConfig {
    type: AutoCoderImportType;
    themeai?: ThemeAIEngineConfig;
}
export interface ApifyRunInfo {
    run_id: string;
    actor_id: string;
    status: string;
    default_dataset_id?: string;
    started_at: number;
    finished_at?: number;
    error_message?: string;
    messages?: string[];
    items_scraped?: number;
    runtime_seconds?: number;
    skipped_empty?: number;
    status_message?: string;
    actor_index?: number;
}
export interface YouTubeDataSourceConfig {
    url: string;
    max_comments?: number;
    include_replies?: boolean;
}
export interface InstagramDataSourceConfig {
    url: string;
    max_comments?: number;
    include_replies?: boolean;
}
export interface TikTokDataSourceConfig {
    video_url: string;
    max_comments?: number;
    include_replies?: boolean;
}
export interface ApifyDataSourceConfig {
    source_type: string;
    dataset_id?: string;
    text_field?: string;
    id_field?: string;
    tiktok?: TikTokDataSourceConfig;
    instagram?: InstagramDataSourceConfig;
    youtube?: YouTubeDataSourceConfig;
    run_info?: ApifyRunInfo;
}
export interface SourceVariable {
    name: string;
    folder_path: string;
    question: string;
}
export interface CarbonDataSourceConfig {
    variable: SourceVariable;
    filter?: string;
}
export interface DataSourceConfig {
    type: DataSourceType;
    carbon?: CarbonDataSourceConfig;
    apify?: ApifyDataSourceConfig;
}
export interface AutoCoderImportConfig {
    name: string;
    description: string;
    prompt: string;
    import_type: AutoCoderImportType;
    data_source?: DataSourceConfig;
    framework_engine?: FrameworkEngineConfig;
    frameworks: AutoCoderFramework[];
    accumulated_suggestions: AutoCoderFrameworkSuggestion[];
    total_cases: number;
    prompt_settings?: PromptSettings;
    use_mock_llm?: boolean;
    variable_path?: string;
    variable_names?: VariableNames;
    connector_enabled?: boolean;
    coding_enabled?: boolean;
    billing_team_id?: string;
}
export interface AutoCoderPipeline {
    id: string;
    created_at: number;
    customer: string;
    job: string;
    system_name?: string;
    lifecycle?: PipelineLifecycle;
    user: string;
    state: string;
    error: string;
    config?: AutoCoderImportConfig;
    labels: {[key: string]: string};
    mode: PipelineMode;
    data_status: DataImportStatus;
    coding_status: CodingStatus;
    data_error: string;
    coding_error: string;
    data_retry_count: number;
    data_retried_at: number;
    dispatched_at: number;
    metadata?: {[key: string]: string};
    records?: AutoCoderPipelineRecord[];
    /** The billed team's name; absent when the pipeline names none. Sent by the pipeline reads (per-pipeline billing team). */
    billing_team_name?: string;
    /** The address the pipeline's batches are attributed to: serviceaccount+<team-slug>@… with a team, else the billing address. */
    attributed_email?: string;
}

export interface LabelValue {
    value: string;
    count: number;
    // Optional human-readable name for `value`, present only where the two
    // differ — a campaign filters on the opaque id "2531_13" and must display
    // "Ents (Sky CA)".
    label?: string;
}
export interface GroupedMetadata {
    metadata: {[key: string]: LabelValue[]};
    total_records: number;
}










export interface ThemeAIImportConfig {
    name: string;
    description: string;
    variable: SourceVariable;
    themes: AutoCoderCode[];
    suggestions: AutoCoderCode[];
    messages: ChatMessage[];
    batch_size: number;
    prompt: string;
}
export interface CarbonInterviewRawDataColumn {
    variable_id: string;
    variable_name: string;
    data: string;
}
export interface CarbonInterviewRawDataRow {
    interview_id: string;
    data: CarbonInterviewRawDataColumn[];
}
export interface CarbonInterviewRawData {
    limit: number;
    offset: number;
    total: number;
    rows: CarbonInterviewRawDataRow[];
}
export interface EntityQuery {
    labelFilters?: {[key: string]: string[]};
    platforms?: string[];
    kinds?: string[];
    // Sprinklr campaign ids (OR within). NOT the same as labelFilters.campaign:
    // this is the real column, carrying Sprinklr's id rather than whatever
    // display name the channel manifest stamped. The `none` / `unknown`
    // sentinels are selectable on purpose.
    campaigns?: string[];
    publishedDateRange?: DateRange;
    metricRanges?: {[key: string]: RangeFilter};
    entityIds?: string[];
    importBatchId?: string;
    search?: string;
    // Find ONE post by its permalink — the paste-a-link lookup. Not `search`:
    // that is an unindexed ILIKE over name and url (fine for a browse box,
    // wrong for a lookup that runs on every paste). The server normalises the
    // paste (tracking parameters, fragment, trailing slash, scheme, `www.`) and
    // also derives the entity key from it, so a link with junk on it still
    // matches. An empty string adds no filter.
    url?: string;
}
export interface DateRange {
    from?: string;
    to?: string;
}
export interface RangeFilter {
    min?: number;
    max?: number;
}
export interface LabelQuery {
    textFilters?: {[key: string]: string[]};
    rangeFilters?: {[key: string]: RangeFilter};
    publishedDateRange?: DateRange;
    commentDateRange?: DateRange;
    metadataFilters?: {[key: string]: string};
    metadataExclusions?: {[key: string]: string[]};
    metadataAny?: {[key: string]: string[]};
    entity?: EntityQuery;
}

// POST /autocoder/:customer/:job/pipelines/:id/submit-batches — THE SEND (T8).
// Hand-maintained mirror of submitBatchesRequest (goapi/pkg/server/autocoder_send.go)
// — a route-local type, not one of types.go's, because the selector and batch
// shapes it resolves into never cross the wire (see AddCodingBatchesToPipelineResult's
// comment below). Customer, job, pipeline and the attributed identity come from
// the route and the token, so they are absent here. The selectors AND together
// and at least one is required.
export interface SubmitBatchesRequest {
    recordIds?: string[];
    importBatchId?: string;
    entity?: EntityQuery;
    // groupBy names a record column (whitelisted server-side) to split the
    // selection by before packing — each distinct value becomes its own
    // labelled batch(es). Absent means one ungrouped, unlabelled pass.
    groupBy?: string;
}

// Hand-maintained mirror of types.AddCodingBatchesToPipelineResult
// (goapi/pkg/types/autocoder.go) — the response body of the send route.
//
// Its two siblings are deliberately NOT mirrored here. `SendableRecordSelector`
// and `AddCodingBatchesToPipelineRequest` are STORE-LAYER call shapes that never
// cross the wire: the browser sends a selector plus an optional groupBy, and the
// server resolves it to records, packs them and forms the batches itself. The
// browser never holds a record id list or a batch. Mirroring them would invite a
// caller to think it could send one.
export interface AddCodingBatchesToPipelineResult {
    batchesCreated: number;
    codingsOpened: number;
    alreadyInFlight: number;
    // BatchesDropped is batches that ended up owning no codings after stamping (every record they
    // named was already in flight) and were deleted rather than left to sit empty.
    batchesDropped: number;
}

// The submit-batches response body: AddCodingBatchesToPipelineResult plus
// `remaining`. remaining > 0 means this call hit the server's per-pass bound
// (submitBatchesPassLimit records) — the caller MUST call again with the same
// selection until remaining is 0, or a selection larger than one pass silently
// sends only its first pass. See useSendToPipeline, which owns the loop.
export interface SubmitBatchesResult extends AddCodingBatchesToPipelineResult {
    remaining: number;
}

export interface MultiPipelineRecordsResponse {
    records: AutoCoderPipelineRecord[];
    frameworks_map: {[key: string]: AutoCoderFramework[]};
    total_count: number;
    limit: number;
    offset: number;
}
export interface QueryPipelinesRequest {
    customer: string;
    job: string;
    labelQuery?: LabelQuery;
    limit: number;
    offset: number;
}
export interface AutoCoderEntity {
    id: string;
    customer: string;
    job: string;
    externalId: string;
    kind: string;
    name: string;
    url: string;
    platform: string;
    publishedDate?: Time;
    import_batch_id?: string;
    labels?: {[key: string]: string};
    createdAt: Time;
    updatedAt: Time;
}

export interface EntityMetricBounds {
    metric: string;
    min: number;
    max: number;
    displayName: string;
    format: string;
}
/** One metric's stored value ON ONE ENTITY, with the catalog's display
 *  metadata. Not EntityMetricBounds (the sidebar's slider range) and not the
 *  aggregated number /entities/metrics/query returns — this is "what does this
 *  post currently say". `displayName` and `format` fall back to the key and
 *  "number" for metrics the catalog does not know; the API response is the ONLY
 *  carrier of percent-vs-number rendering (the frontend's PIPELINE_METRICS
 *  table was deleted in EN-T20). */
export interface EntityMetricReading {
    metric: string;
    value: number;
    agg: string;
    displayName: string;
    format: string;
    source?: string;
    observedAt: Time;
}

/** GET /autocoder/:customer/:job/entities/:id, and the body a successful PATCH
 *  answers with.
 *
 *  `labels` is lifted out of `entity` on purpose: AutoCoderEntity.labels is
 *  `omitempty` on the Go side and encoding/json omits an EMPTY map too, so an
 *  entity with no labels would arrive with no key at all. Read labels from
 *  here, not from `entity.labels`. Both maps are always present. */
export interface EntityDetailResponse {
    entity: AutoCoderEntity;
    labels: {[key: string]: string};
    metrics: {[key: string]: EntityMetricReading};
}

/** PATCH /autocoder/:customer/:job/entities/:id.
 *
 *  THREE STATES, and they are the same here as in the CSV round trip:
 *    absent key      → left untouched
 *    null OR ""      → deleted
 *    anything else   → written
 *
 *  Labels are strings and metrics are numbers, and the server REFUSES the
 *  confusion with a 400 naming the key rather than coercing — that confusion
 *  (#1194) is what silently lost Sky's U35 data. Send a real number, never a
 *  formatted string ("36.8%", "12,000"); the CSV import tolerates those shapes,
 *  this door does not.
 *
 *  Unknown metric keys are writable (Sky adds their own) but must be
 *  lower_snake_case.
 *
 *  🔴 METRIC KEYS ARE CANONICALISED SERVER-SIDE. A legacy key resolves to its
 *  catalog key before it is stored OR deleted — `u35_percent` and `u35_viewers`
 *  both become `u35_pct`, `tiktok_video_views` becomes `video_views`. This is
 *  why you must NOT normalise a typed metric name with the CSV header helper
 *  and send the result expecting it back verbatim: send whatever you have and
 *  read the canonical key out of the response, which always echoes what was
 *  actually stored. Sending two spellings of one metric in one body is a 400.
 *
 *  The reason is #1194: a shape-valid key is not a canonical key, and a number
 *  stored under `u35_percent` is read by nothing — KPI_METRIC_KEYS and cultural
 *  relevance both ask for `u35_pct`. */
export interface EntityPatchRequest {
    labels?: {[key: string]: string | null};
    metrics?: {[key: string]: number | string | null};
}

/** POST /autocoder/:customer/:job/entities/import — multipart {file, token?}.
 *
 *  🔴 THE DRY RUN IS STRUCTURAL, NOT A FLAG. There is no "apply" parameter.
 *  Post the file with NO token to get a preview (writes nothing) plus a `token`;
 *  post the SAME bytes again with that token to apply. A token is bound to the
 *  file's digest and expires, so you cannot preview one file and apply another,
 *  and you cannot write without having previewed.
 *
 *  Semantics, identical to EntityPatchRequest above:
 *    absent COLUMN → never touched (a trimmed export is safe to re-upload)
 *    blank CELL    → deletes that value
 *    otherwise     → written
 *
 *  Column vocabulary: `entity_id` (required, the match key — never the url),
 *  `label:<key>`, `metric:<key>`, and the read-only promoted columns the export
 *  emits, which are recognised and ignored. Anything else is reported in
 *  `unknownColumns` and ignored.
 *
 *  An apply is refused outright if the plan carries any column or row error. */
export interface EntityImportResult {
    /** Present on a preview only; authorises exactly one apply of these bytes. */
    token?: string;
    expiresAt?: Time;
    applied: boolean;
    totalRows: number;
    matchedRows: number;
    /** Rows actually written (apply only). Unchanged rows are not written, so
     *  this is never simply matchedRows. */
    entitiesUpdated: number;
    /** Counted per CELL, not per row. */
    counts: EntityImportCounts;
    unmatchedEntityIds: string[];
    unknownColumns: string[];
    /** Recognised and IGNORED — surfaced so an edit to `name` or `url` does not
     *  vanish silently. */
    readOnlyColumns: string[];
    /** Keys no matched entity currently carries: a misspelling warning, or on
     *  the U35 recovery the expected "coming back from nothing" signal.
     *  newMetricKeys are CANONICAL keys — a `metric:u35_percent` heading that
     *  resolves onto an existing `u35_pct` is not new and is not listed. */
    newLabelKeys: string[];
    newMetricKeys: string[];
    columnErrors: EntityImportColumnError[];
    rowErrors: EntityImportRowError[];
    /** Listed individually, not just counted — these are the irreversible half.
     *  The count in `counts.delete` is always exact; this list is capped. */
    deletions: EntityImportDeletion[];
    deletionsTruncated: boolean;
}

export interface EntityImportCounts {
    add: number;
    change: number;
    delete: number;
    unchanged: number;
}

export interface EntityImportColumnError {
    column: string;
    reason: string;
}

export interface EntityImportRowError {
    /** 1-based line in the file; the header is line 1. */
    row: number;
    entityId: string;
    column?: string;
    value?: string;
    reason: string;
}

export interface EntityImportDeletion {
    row: number;
    entityId: string;
    column: string;
    currentValue: string;
}

export interface EntityFilterSummary {
    labels: {[key: string]: LabelValue[]};
    platforms: LabelValue[];
    campaigns: LabelValue[];
    metrics: EntityMetricBounds[];
    publishedRange?: DateRange;
    totalEntities: number;
}
/** What each button of the platform control is worth, UNDER THE PAGE'S CURRENT
 *  FILTERS with the platform choice removed (POST /entities/platform-counts).
 *  ⚠ The per-platform rows do NOT sum to the totals: a platform button is an
 *  entity semi-join, where the totals send no platform constraint and so also
 *  keep the comments whose parent post could not be identified. */
export interface PlatformToggleCounts {
    videos: LabelValue[];
    comments: LabelValue[];
    totalVideos: number;
    totalComments: number;
}
export interface BatchImportResult {
    customer: string;
    job: string;
    pipeline_ids: string[];
    pipelines_created: number;
    total_pipelines: number;
    error?: string;
}
export interface BatchPipelineConfig {
    video_url: string;
    pipeline_name: string;
    platform: string;
    labels: {[key: string]: string};
    metadata: {[key: string]: string};
}
export interface BatchImportPreviewResponse {
    columns: string[];
    pipelines: BatchPipelineConfig[];
    warnings?: string[];
}
export interface AnalyzedColumn {
    name: string;
    normalized_key: string;
    sample_values: string[];
}
export interface BatchImportAnalyzeResponse {
    columns: AnalyzedColumn[];
    detected_url_column: string;
    platform_breakdown: {[key: string]: number};
    unrecognized_count: number;
    unrecognized_samples: string[];
    total_rows: number;
}


export interface TableVisibilitySettings {
    frequency: boolean;
    column_percent: boolean;
    row_percent: boolean;
    significance: boolean;
}
export interface TableViewSettingsData {
    visibility: TableVisibilitySettings;
    vertical_coefficient: number;
    horizontal_coefficient: number;
    chart_type: string;
    data_type: string;
    selected_rows: string[];
    selected_columns: string[];
    selected_column?: string;
    switch_axis: boolean;
    view_mode?: string;
}
export interface WebappDashboardConfig {
    session_id: string;
    entry_point: string;
    azure_prefix: string;
    job: string;
    /** The workspace directory the files were published from (e.g. "data"). Recorded since #1416; absent on older dashboards. */
    dist_path?: string;
}
export interface VideoDashboardConfig {
    session_id: string;
    artifact_id: string;
    job: string;
    file_path: string;
    source_path: string;
    file_name: string;
    file_size: number;
    mime_type: string;
}
export interface BrandPaletteEntry {
    color: string;
    aliases?: string[];
}
export interface DashboardPage {
    id: string;
    name: string;
    layout: DashboardLayout;
    context?: string;
    /** BrandTheme id, stored as a LIVE reference and resolved at render (#1182) — never a copy of the colours. Resolution order: page theme → job palette. */
    brand_palette_key?: string;
    /** This page's own filter expression (#1183) — same syntax as global_filter. Dashboard and page filters always COMPOUND as (dashboard) AND (page); see utils/dashboardFilters.ts. */
    filter?: string;
    /** Per-job page filters for a multi-job dashboard (#1162): job id → expression. The legacy `filter` string is read as the primary job's entry; the first multi-job write populates this. See resolveWidgetFilter. */
    filters?: {[key: string]: string};
}
export interface DashboardRowDisplayProperties {
    height?: number;
}
export interface CalloutWidgetData {
    title: string;
    body: string;
    icon?: string;
    style?: string;
}
export interface KPICardWidgetData {
    value: string;
    label: string;
    trend?: string;
    trend_value?: string;
    description?: string;
    accent?: string;
}
export interface TOCEntry {
    label: string;
    target_id?: string;
}
export interface TOCWidgetData {
    mode: string;
    entries?: TOCEntry[];
}
export interface TitleHeroWidgetData {
    heading: string;
    subtitle?: string;
    badge?: string;
    size: string;
    alignment: string;
    bg_color?: string;
    text_color?: string;
}
export interface SelectedConversationItem {
    kind: string;
    tool_call_id?: string;
    artifact_id?: string;
    artifact_file_path?: string;
    message_id?: string;
    content?: string;
    label: string;
}
export interface AgentArtifactWidgetData {
    session_id: string;
    title?: string;
    artifact_filter?: string[];
    max_items: number;
    layout: string;
    selected_items?: SelectedConversationItem[];
}
/** What a new chat is seeded from (presentations): a chat's story board artifact, or a published DataViz web app. */
export type SeedSourceKind = 'artifact' | 'dashboard';
/**
 * Body of POST /agent/session/:sessionId/seed. `at` is the slide and the
 * innermost open layer (the story lint's id rule); omitted for a plain story
 * page. figure.row/col are the dataset's data indexes (data-pt-cell), 0 to 100000.
 */
export interface SeedSessionRequest {
    source: { kind: SeedSourceKind; id: string };
    at?: { slide: string; layer?: string };
    figure?: { dataset: string; row: number; col: number };
}
/** Reply of the seed route: the chat-relative folder the copy is in, "from/<kind>-<id8>". */
export interface SeedSessionResponse {
    dir: string;
}
/** session.metadata.seeded_from, written by the seed route. The title is the server's, not the page's. */
export interface SeededFrom {
    kind: SeedSourceKind;
    id: string;
    dir: string;
    title: string;
    at?: { slide: string; layer?: string };
    figure?: { dataset: string; row: number; col: number };
}
export interface XSpecProperties {
    topInsert?: string;
    sideInsert?: string;
    level?: string;
    caseFilter?: string;
    initAsMissing: boolean;
    excludeNE: boolean;
    padHierarchics: boolean;
    arithOverStats: boolean;
    fullStats: boolean;
}
export interface POutput {
    format: string;
}
export interface PCorner {
    priority: string;
    netResp: boolean;
}
export interface PSignificance {
    visible: boolean;
    type: string;
    propStat: string;
    meanStat: string;
    statsParam?: string;
    autoParam: boolean;
    letterSequence?: string;
    letters: string;
    appendLetters: boolean;
    headcount: string;
    meanPoolVariance: boolean;
    propPooledEst: boolean;
    continuityCorr: boolean;
    skipBase30: boolean;
    skipCell5: boolean;
    lettersLong: boolean;
    oneTailed: boolean;
    hiLoTest: boolean;
    sigLevel1?: number;
    sigLevel2?: number;
    sigLevel3?: number;
}
export interface XDecimals {
    frequencies: number;
    percents: number;
    statistics: number;
    expressions: number;
}
export interface PCells {
    frequencies: boolean;
    columnPercents: boolean;
    rowPercents: boolean;
    percentSign: boolean;
    missingAsZero: boolean;
    missingAsBlank: boolean;
    zeroAsBlank: boolean;
    blankAsChar: boolean;
    blankChar?: string;
    percentsAsProportions: boolean;
    showRedundant100: boolean;
    thousandsSeparator: boolean;
}
export interface XHide {
    active: boolean;
    missing: boolean;
    empty: boolean;
    vectors?: string;
}
export interface XSort {
    active: boolean;
    increasing: boolean;
    ungrouped: boolean;
    band: string;
    type: string;
    key: number;
}
export interface PLabels {
    width: number;
    height: number;
    labelling?: VLabelling;
    visible: boolean;
}
export interface VLabelling {
    name: boolean;
    desc: boolean;
}
export interface EText {
    labelling?: VLabelling;
    visible: boolean;
}
export interface PEdge {
    groups?: EText;
    labels?: PLabels;
    sort?: XSort;
    hide?: XHide;
    baseCount: boolean;
}
export interface XLabelling {
    script: boolean;
    codes: boolean;
    name: boolean;
    desc: boolean;
}
export interface PTitles {
    name: boolean;
    top: boolean;
    side: boolean;
    filter: boolean;
    weight: boolean;
    status: boolean;
    labelling?: XLabelling;
}
export interface PlatinumProperties {
    description?: string;
    titles?: PTitles;
    top?: PEdge;
    side?: PEdge;
    cells?: PCells;
    decimals?: XDecimals;
    significance?: PSignificance;
    corner?: PCorner;
    output?: POutput;
}
export interface CarbonSpec {
    customerName?: string;
    jobName?: string;
    vartreeName?: string;
    top?: string;
    side?: string;
    filter?: string;
    weight?: string;
    caseFilter?: string;
    useFilter: boolean;
    useWeight: boolean;
    outputFormat: string;
    displayProperties?: PlatinumProperties;
    specProperties?: XSpecProperties;
    labelQueryJson?: string;
    source?: string;
}
export interface RelativeCoord {
    anchor: string;
    offset: number;
}
export interface TableRange {
    row_start: RelativeCoord;
    row_end: RelativeCoord;
    col_start: RelativeCoord;
    col_end: RelativeCoord;
}
export type ColumnSelectionMode = 'fixed' | 'rolling';
export type ColumnSelectionAnchor = 'end' | 'start';

/**
 * Which columns (waves/periods) a chart shows — a rule, not a result (D2).
 * "Latest three" re-resolves as new waves land. Resolved by
 * utils/tableSelection.ts before anything downstream sees it.
 */
export interface ColumnSelection {
    mode: ColumnSelectionMode;
    /** mode === 'fixed' */
    names?: string[];
    /** mode === 'rolling' */
    count?: number;
    /** mode === 'rolling'; defaults to 'end' (most recent) */
    anchor?: ColumnSelectionAnchor;
}

/** Tier 1 view filter: the window into the table, never the table itself. */
export interface TableGraphSelection {
    /** Row/brand names to show. Empty or absent means all. */
    rows?: string[];
    /** Column rule. Absent means all. */
    columns?: ColumnSelection;
    /**
     * What `columns` resolved to at sign-off. Overrides the rule while set, so
     * a signed dashboard does not move when a new wave lands. Cleared when
     * sign-off is revoked.
     */
    pinned_columns?: string[];
    switch_axis?: boolean;
}

/**
 * Per-axis design override (#968 Part C). Every field is optional — absent
 * means "inherit the design-system default", not "inherit zero/empty". See
 * ../utils/chartDesign.ts (resolveChartDesign) for the merge, and
 * ChartAxisDesign in goapi/pkg/types/types.go for the mirrored Go doc.
 */
export interface ChartAxisDesign {
    label_font_size?: number;
    label_color?: string;
    title_text?: string;
    title_color?: string;
    /** Value-axis minimum (#1178). Stored on the y_axis section; applied to whichever built axis is type 'value' — X on horizontal bar types. Units follow the data: a percentage chart takes fractions (1 = 100%). */
    min?: number;
    /** Value-axis maximum (#1178). Same routing and units as min. A max below the data's top clips the chart — a legitimate choice. */
    max?: number;
    /** Value-axis major unit → ECharts axis `interval` (gridline/tick step), NOT axisLabel.interval (#1178). */
    major_unit?: number;
    /** Category-axis label thinning (#1178), USER-facing semantics: absent = ECharts 'auto', 1 = every label, N = every Nth (maps to ECharts axisLabel.interval N-1). Stored on the x_axis section; applied to whichever built axis is type 'category'. */
    label_interval?: number;
    /** Category-axis range slider (#1172): opts a chart INTO the dataZoom slider the line generator used to ship unconditionally. Absent/false = no slider (the new default). Stored on the x_axis section; applied only when the built X axis is type 'category'. */
    range_slider?: boolean;
}
export type ChartGridlineDashStyle = 'solid' | 'dashed' | 'dotted';
export interface ChartGridlinesDesign {
    color?: string;
    width?: number;
    dash_style?: ChartGridlineDashStyle;
}
/** Legend position (#1044). */
export type ChartLegendPosition = 'top' | 'bottom' | 'left' | 'right';
/**
 * Legend design override (#1044). Show/hide composes with the existing
 * hideLegend post-processing in PlatinumGraphs.tsx — hideLegend always wins
 * when set, this governs what shows otherwise. Position defaults to 'top'
 * (see CHART_LEGEND_TOP in generators/helpers.ts); an explicit 'bottom' is
 * still honored even though it can collide with the dataZoom slider.
 */
export interface ChartLegendDesign {
    show?: boolean;
    position?: ChartLegendPosition;
    font_size?: number;
    font_color?: string;
    /**
     * false hides each entry's coloured swatch and keeps its text (Matt, 14
     * Oct 2026: a bar chart coloured by value rules shows a series swatch
     * that means nothing). Absent = shown.
     */
    show_symbol?: boolean;
}
/**
 * Data-label number format (#1044). 'auto' matches the widget's Data Type —
 * see buildDataLabelFormatter in ../utils/applyChartDesign.ts.
 */
export type ChartDataLabelNumberFormat = 'auto' | 'integer' | 'percent0' | 'percent1' | 'percent2';
export interface ChartDataLabelsDesign {
    show?: boolean;
    number_format?: ChartDataLabelNumberFormat;
}
export type ChartTitleAlign = 'left' | 'center' | 'right';
/** Chart title formatting override (#1044) — the title text itself is TableGraphWidgetData.title. */
export interface ChartTitleDesign {
    align?: ChartTitleAlign;
    font_size?: number;
    font_weight?: number;
    color?: string;
}
/**
 * Chart design overrides embedded on a widget (#968 Part C, extended #1044
 * with legend/data-labels/title) — travels with the widget on copy/paste and
 * column copy (#967) because it lives here, not in an external store.
 * Per-series color already has its own hierarchy via `color_overrides`
 * below; this covers the rest of the surfaced design controls. Resolution
 * against the design-system default happens in ../utils/chartDesign.ts
 * (resolveChartDesign) — the single source of truth for the
 * override/revert-to-theme hierarchy.
 */
export interface ChartDesign {
    x_axis?: ChartAxisDesign;
    y_axis?: ChartAxisDesign;
    gridlines?: ChartGridlinesDesign;
    legend?: ChartLegendDesign;
    data_labels?: ChartDataLabelsDesign;
    title?: ChartTitleDesign;
}
/**
 * Tier 1 view config for a widget in TABLE mode (#969 Part B) — a BLOCKLIST.
 * Everything in the source table shows by default; only an explicit hide
 * removes it, so a row or column added by a wave refresh flows through with no
 * edit to the widget.
 *
 * Deliberately NOT `TableGraphSelection`, which is an allowlist and right for
 * a chart. A widget in table mode reads `view_config`, in graph mode
 * `selection`. Ids are paths through the axis hierarchy joined with U+001F —
 * see ../utils/tableViewConfig.ts, which owns the tree and applies all of
 * this, and TableViewConfig in goapi/pkg/types/types.go for the mirrored doc.
 */
export interface TableViewConfig {
    /** Row-node paths to hide. Hiding a node hides its whole subtree. */
    hidden_rows?: string[];
    /** Column-node paths to hide, same rule. */
    hidden_columns?: string[];
    /** Display order applied within each set of siblings; unlisted nodes hold their table position. */
    row_order?: string[];
    column_order?: string[];
    /** Pixel widths keyed by column-node path (#969 Part C). */
    column_widths?: {[key: string]: number};
    /** Pin the stub and column headers. Absent means the default, which is on. */
    freeze_headers?: boolean;
}

/**
 * Table widget design overrides, per header level (#969 Part C). The render
 * seam (platinum-table-new/styles.ts, GridCell.type) distinguishes 'group'
 * cells (intermediate nesting, e.g. Gender) from 'label' cells (leaf headers,
 * e.g. Male/Female) — that existing distinction is the "header level" this
 * is keyed by. See ../utils/tableDesign.ts (resolveTableDesign) for the merge.
 */
export interface TableHeaderLevelDesign {
    background_color?: string;
    text_color?: string;
    font_weight?: number;
}
export interface TableHeaderDesign {
    group?: TableHeaderLevelDesign;
    label?: TableHeaderLevelDesign;
}
export type TableCellAlignment = 'left' | 'center' | 'right';
export interface TableCellDesign {
    font_size?: number;
    alignment?: TableCellAlignment;
    border_color?: string;
    border_width?: number;
    gridlines_visible?: boolean;
}
export type TableConditionalFormatComparator = 'gt' | 'gte' | 'lt' | 'lte' | 'eq' | 'between';
/**
 * One value-threshold conditional-formatting rule (#969 Part C, e.g.
 * "cell % > 50 -> green background"). Rules are stored as an ordered list on
 * TableDesign and evaluated in order — first match wins. See
 * ../utils/tableConditionalFormat.ts for the pure evaluator.
 */
export interface TableConditionalFormatRule {
    comparator: TableConditionalFormatComparator;
    threshold: number;
    /** Upper bound for the "between" comparator, where `threshold` is the lower bound (inclusive both ends). */
    threshold_upper?: number;
    background_color?: string;
    text_color?: string;
}
export type TableSignificanceEmphasis = 'none' | 'bold' | 'italic';
export interface TableSignificanceDesign {
    color?: string;
    emphasis?: TableSignificanceEmphasis;
}
/**
 * Table widget design overrides embedded on a widget (#969 Part C) —
 * travels with the widget on copy/paste and column copy (#967) because it
 * lives here, not in an external store. Same override/revert-to-theme model
 * as ChartDesign, resolved in ../utils/tableDesign.ts (resolveTableDesign).
 */
export interface TableDesign {
    header?: TableHeaderDesign;
    cell?: TableCellDesign;
    conditional_formatting?: TableConditionalFormatRule[];
    significance?: TableSignificanceDesign;
}

/**
 * A table's column and row labels as of the last dashboard sign-off (#969
 * Part F) — the baseline the Review Changes panel diffs the live table
 * against to find new columns/rows. Captured client-side at sign-off time
 * (see utils/dashboardSignOffSnapshot.ts); undefined means no baseline
 * (never signed off, or signed off before this field existed).
 */
export interface TableColumnRowSnapshot {
    columns?: string[];
    rows?: string[];
}
export interface TableGraphWidgetData {
    job: string;
    table_path: string;
    view_mode: string;
    chart_type?: string;
    data_type?: string;
    selection?: TableGraphSelection;
    /** Superseded by `selection`; converted on load. Do not write. */
    range?: TableRange;
    color_overrides?: {[key: string]: string};
    title?: string;
    spec?: Record<string, unknown>;
    /** Chart design overrides (#968 Part C) — axis labels/titles, gridlines. */
    design?: ChartDesign;
    /** Table-mode view config (#969 Part B) — hide list, order, widths, freeze. */
    view_config?: TableViewConfig;
    /** Table design overrides (#969 Part C) — header/cell styling, conditional formatting, significance. Applies only in table view mode. */
    table_design?: TableDesign;
    /** Column/row labels captured at the last dashboard sign-off (#969 Part F). */
    sign_off_snapshot?: TableColumnRowSnapshot;
    /** BrandTheme id held as a LIVE reference (#1193), same model as DashboardPage.brand_palette_key. Resolution: chart theme → page theme → job palette; a hand-set color_overrides entry still wins. */
    brand_palette_key?: string;
    /** Skip zero-base points (#1181). Absent/undefined = ON (charts saved before the field existed pick it up); explicit false = off. */
    skip_zero_base?: boolean;
}
export interface VideoWidgetData {
    job: string;
    file_path: string;
    embed_url?: string;
    /** Horizontal position within the cell when max_width < 100: "left", "center" (default), or "right". #1071. */
    align?: string;
    /** Embed width as a percentage of the cell (60/80/100; 100 is the default/full-bleed). #1071. */
    max_width?: number;
    /** Iframe aspect ratio: "16:9" (default), "9:16", "4:3", or "1:1". #1071. */
    aspect_ratio?: string;
    /** Embed-native playback options, applied only where the provider (YouTube/Vimeo) supports the param; degrades gracefully otherwise. #1071. */
    autoplay?: boolean;
    mute?: boolean;
    loop?: boolean;
    /** Start time in seconds. */
    start_time?: number;
    hide_controls?: boolean;
}
export interface ImageWidgetData {
    job: string;
    file_path: string;
    alt_text?: string;
    /** How the image is scaled within its cell: "contain" (default) or "cover". #1069. */
    fit_mode?: string;
    /** Horizontal position within the cell when the image doesn't fill it: "left", "center" (default), or "right". #1069. */
    align?: string;
}
// DashboardMedia mirrors goapi/pkg/types/types.go DashboardMedia (#1070).
// Hand-added — gotypes.ts is hand-maintained, never regenerate it.
export interface DashboardMedia {
    id: string;
    customer: string;
    job: string;
    dashboard_id: string;
    blob_path: string;
    filename: string;
    size_bytes: number;
    content_type: string;
    uploaded_by: string;
    created_at: string;
}
export interface CardTextAttribution {
    user_email: string;
    edited_at: number;
}
export interface CardSignOff {
    user_email: string;
    signed_at: number;
    wave_ref?: string;
    /** The MultiTableAnalysis whose combined_report was on screen when the card was signed. */
    analysis_id?: string;
}
export interface DashboardSignOff {
    user_email: string;
    signed_at: number;
    wave_refs?: {[key: string]: string};
    /** multi_table_id -> the analysis signed for that card. */
    analysis_ids?: {[key: string]: string};
}
export interface DashboardSignOffRevoked {
    revoked_by: string;
    revoked_at: number;
    previous_user?: string;
}
/** Structured "bullets/prose, length, audience" selection for one instructions
 *  field (#1047), persisted alongside the free-text instructions so the
 *  editor can re-derive the toggle UI on reopen instead of always showing
 *  defaults. Plain strings, not the literal-typed `GuidedToggleState` used by
 *  the toggle UI (`wizardHelpers.ts`) — validate with `sanitizeGuidedToggles`
 *  before trusting a value read back from storage. */
export interface GuidedToggles {
    format?: string;
    length?: string;
    audience?: string;
}
export interface MultiTableAnalysisWidgetData {
    multi_table_id: string;
    job: string;
    title?: string;
    /** Title formatting (#1247) — the same ChartTitleDesign chart widgets use (#1044). */
    title_design?: ChartTitleDesign;
    persona?: string;
    user_context?: string;
    synthesis_user_context?: string;
    output_length?: string;
    edited_report?: string;
    analysis_instructions?: string;
    synthesis_instructions?: string;
    /** The structured selection behind analysis_instructions' trailing
     *  guidance sentence (#1047). Absent for widgets saved before this
     *  existed — the editor then best-effort parses the sentence instead. */
    analysis_guided_toggles?: GuidedToggles;
    synthesis_guided_toggles?: GuidedToggles;
    // Attribution & sign-off (#963)
    edited_by?: CardTextAttribution;
    signed_off?: CardSignOff;
    sign_off_requested?: boolean;
    /** One-shot twin of sign_off_requested (#1256): revoke the card sign-off; reset server-side. */
    sign_off_revoke_requested?: boolean;
    awaiting_review?: boolean;
    needs_review?: boolean;
    /** Latest generated report, embedded server-side into unauthenticated
     *  shared-dashboard payloads only (#970 Obs 2). Never persisted. */
    shared_report?: string;
    /** Unix-millis generation time of shared_report, so a share viewer sees the "AI generated" label (#1247). */
    shared_generated_at?: number;
    /** Citation label -> full table path map embedded alongside shared_report
     *  so shared viewers' citation chips resolve. Never persisted. */
    shared_table_paths?: { [key: string]: string };
    /** The card's "Based on" caption (#2014), embedded for shared viewers. Never persisted. */
    shared_based_on?: string;
}
export interface CardSnapshotConfig {
    persona?: string;
    user_context?: string;
    synthesis_user_context?: string;
    output_length?: string;
    analysis_instructions?: string;
    synthesis_instructions?: string;
}
export interface DashboardCardSnapshot {
    id: string;
    created_at: number;
    dashboard_id: string;
    customer: string;
    multi_table_id: string;
    version: number;
    trigger_reason: string;
    triggered_by: string;
    ai_original_text: string;
    human_final_text: string;
    referenced_tables: string[];
    wave_ref?: string;
    config_snapshot?: CardSnapshotConfig;
}
export interface TipTapDocument {
    type: string;
    content?: any[];
}
export interface DashboardTextData {
    content: string;
    tiptap_content?: TipTapDocument;
}
export interface DashboardCellDisplayProperties {
    width?: number;
}
export interface DashboardCell {
    widget_type: string;
    display_props?: DashboardCellDisplayProperties;
    text_data?: DashboardTextData;
    layout_data?: DashboardLayout;
    multi_table_analysis_data?: MultiTableAnalysisWidgetData;
    image_data?: ImageWidgetData;
    video_data?: VideoWidgetData;
    table_graph_data?: TableGraphWidgetData;
    agent_artifact_data?: AgentArtifactWidgetData;
    title_hero_data?: TitleHeroWidgetData;
    toc_data?: TOCWidgetData;
    kpi_card_data?: KPICardWidgetData;
    callout_data?: CalloutWidgetData;
    /** Data for the report pillar widget (#1080). */
    report_pillar_data?: ReportPillarWidgetData;
}
/**
 * One entry in a report pillar (#1080). Only two kinds exist, so "a pillar
 * containing an image" is unrepresentable rather than merely discouraged.
 *
 * The entry carries a whole cell because a Gen AI card's title, persona,
 * instructions and synthesis_user_context all live on the CELL, not on the
 * multi-table it points at — which is what lets the existing renderers be
 * reused unchanged. The proposal's `multi_table_id` is still there, one level
 * down, in `cell.multi_table_analysis_data`.
 */
export interface ReportPillarEntry {
    kind: 'title_hero' | 'analysis';
    /** The manifest section this entry came from. EMPTY IS MEANINGFUL: it is
     *  the representation of "not from the manifest" — an addition, not an
     *  error. Stamped at generation/conversion time, never edited in the UI. */
    manifest_section_id?: string;
    cell: DashboardCell;
}
export interface ReportPillarWidgetData {
    /** Mirrors the first title_hero entry's heading; the pillar editor writes
     *  both so they never diverge. */
    heading: string;
    manifest?: string;
    manifest_pillar_id?: string;
    /** Ordered. ORDER IS THE NARRATIVE — nothing else records it, and section
     *  titles repeat across a report. */
    entries: ReportPillarEntry[];
}
export interface DashboardRow {
    cells: DashboardCell[];
    display_props?: DashboardRowDisplayProperties;
}
export interface DashboardLayout {
    rows: DashboardRow[];
}
export interface DashboardConfig {
    name: string;
    description: string;
    objectives?: string;
    /** Metrics (or how they're calculated) to be aware of — feeds the Insights pane (#973). */
    key_metrics?: string;
    layout: DashboardLayout;
    pages?: DashboardPage[];
    global_filter?: string;
    /** Per-job dashboard filters for a multi-job dashboard (#1162): job id → expression. The legacy `global_filter` string is read as the primary job's entry. See resolveWidgetFilter. */
    global_filters?: {[key: string]: string};
    brand_palette?: {[key: string]: BrandPaletteEntry};
    webapp_config?: WebappDashboardConfig;
    video_config?: VideoDashboardConfig;
    sign_off?: DashboardSignOff;
    sign_off_requested?: boolean;
    /** Records a sign-off dropped by a later text edit, so the UI can say who revoked it. */
    sign_off_revoked?: DashboardSignOffRevoked;
    needs_review?: boolean;
    /** Latest data wave (RFC3339) across the jobs this dashboard references. Computed on read, never persisted. */
    data_refreshed_at?: string;
    /** Optional tags attached when saving a dashboard as a template (#971 Phase 2). Only meaningful when the owning Dashboard.type is "template". */
    template_tags?: string[];
    /** Which manifest compiled this dashboard. Only set when Dashboard.type is "exec_report"; a marker, nothing reads it to change behaviour. */
    exec_report?: ExecReportProvenance;
}
/**
 * Provenance for a compiled executive-report dashboard (Dashboard.type ===
 * "exec_report"). Written only by scripts/workflows/exec-reports/create-dashboard.js.
 * A marker: no rendering, editing or permission behaviour depends on it.
 */
export interface ExecReportProvenance {
    /** Manifest folder name, e.g. "sky-uk-prius". */
    manifest?: string;
    /** manifest.metadata.version, e.g. "3.1.0". */
    manifest_version?: string;
    /** manifest.metadata.generatedAt — when the MANIFEST was generated, not this dashboard. */
    generated_at?: string;
}
/** Server-assembled context for the Insights pane (#974) — see GET /dashboards/:customer/:id/insights-context. */
export interface DashboardInsightsContext {
    dashboard_id: string;
    name: string;
    description: string;
    objectives?: string;
    key_metrics?: string;
    customer: string;
    job?: string;
    pages: DashboardInsightsPage[];
    /** Set when the request carried a page_id: `pages` then holds only that page (#974 Stage 1). Empty = legacy whole-dashboard context. */
    scoped_page_id?: string;
    scoped_page_name?: string;
    /** The quick filter active on the view the pane opened over (#1064). The figures in `report_text` were computed WITHOUT it. */
    active_filter?: string;
    sign_off?: DashboardSignOff;
    needs_review: boolean;
    data_refreshed_at?: string;
    /** Count of widgets dropped by the hard per-request cap, so the model can say "and N more" rather than pretending it saw everything. */
    truncated_widget_count?: number;
    /** The analysis profiles of the dashboard's jobs, first in the model's context (#2014). */
    analysis_profile?: string;
    analysis_profiles?: AnalysisProfileRef[];
}
export interface DashboardInsightsPage {
    id: string;
    name: string;
    context?: string;
    widgets: DashboardInsightsWidget[];
}
export interface DashboardInsightsWidget {
    widget_type: string;
    title: string;
    job: string;
    report_text?: string;
    user_context?: string;
    needs_review: boolean;
    signed_off: boolean;
    latest_month?: string;
    /** The widget's own table rendered to markdown for the model (table_graph widgets only), capped by row/column/character budgets. Figures are unfiltered. */
    table_markdown?: string;
    table_rows_shown?: number;
    table_rows_total?: number;
    table_columns_shown?: number;
    table_columns_total?: number;
    /** Which column slice was kept when capped (#1117): first/last labels, and whether it is the newest end of a wave series. */
    table_columns_range_first?: string;
    table_columns_range_last?: string;
    table_columns_newest_kept?: boolean;
    /** The fetch or render failed for this widget alone. */
    table_data_unavailable?: boolean;
    /** The context's overall table-data budget was already spent. */
    table_data_omitted?: boolean;
}
/** One table the user offered the structure generator (#971 Phase 3). Path is the job-relative .cbt path from the table tree. */
export interface GenerateDashboardSourceTable {
    name: string;
    path: string;
}
/** Body for POST /dashboards/:customer/generate-structure (#971 Phase 3 agent-assisted creation). */
export interface GenerateDashboardStructureRequest {
    description: string;
    job: string;
    source_tables?: GenerateDashboardSourceTable[];
}
/** The lowered structure-and-shells-only config; seeds the layout builder — the dashboard is created later by the builder's normal create path. */
export interface GenerateDashboardStructureResponse {
    config: DashboardConfig;
}
export interface Dashboard {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    user: string;
    /** Job this dashboard is scoped to (#961). Since #1162 this is maintained as jobs[0] (the primary job) on every write. Empty on legacy dashboards. */
    job: string;
    /** Jobs this dashboard is scoped to (#1162). Ordered; jobs[0] is the primary, fixed for life. Changed ONLY via the add/remove-job endpoints, never via PUT. Absent/empty on legacy rows. */
    jobs?: string[];
    created_by: string;
    modified_by: string;
    /** Unix timestamp when a Manager/Realm promoted this to company-level (#962). Absent = not promoted. */
    promoted_at?: number;
    promoted_by?: string;
    type: string;
    config?: DashboardConfig;
    share_id?: string;
    share_access_level?: string;
    share_enabled: boolean;
    /** Theme id → current palette, for every theme this dashboard references via brand_palette_key (#1182). Computed server-side on every read, never persisted — theme references are live, and shared (logged-out) viewers cannot call the themes API. */
    resolved_themes?: {[key: string]: {[key: string]: BrandPaletteEntry}};
    /** A web app dashboard whose story board has saved changes not yet published (#1578 item 15). Computed on the list read, never persisted. */
    webapp_unpublished?: boolean;
    /** The dashboard this one was forked from (migration 000157), set by the fork route only; the email domain list's dashboard grant follows it. */
    forked_from?: string;
}
/** A reusable, design-only chart preset (#1050 — "Save as chart template"). No table reference, no data, no title text — chart type + ChartDesign overrides + colour overrides only. Storage mirrors Dashboard templates (customer scoping, personal by default, Manager/Realm promotion) in its own table. */
export interface ChartTemplate {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    user: string;
    created_by: string;
    name: string;
    description?: string;
    chart_type?: string;
    design?: ChartDesign;
    color_overrides?: { [key: string]: string };
    /** Unix timestamp when a Manager/Realm promoted this to company-level. Absent = not promoted. */
    promoted_at?: number;
    promoted_by?: string;
}

/** One persona in a customer's personas library (#1523), types.Persona. */
export interface Persona {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    /** Email of the person who made it; empty for a persona nobody owns. */
    owner: string;
    name: string;
    prompt: string;
    /** Unix timestamp when a Manager/Realm made it Company-level. Absent = personal. */
    promoted_at?: number;
    promoted_by?: string;
    /** True only on the built-in personas, which are read-only. */
    standard?: boolean;
}

/** GET /personas/:customer — the library's tiers, plus the pre-#1523 flat list. */
export interface PersonasListResponse {
    exec: Persona[];
    mine: Persona[];
    colleagues: Persona[];
    /** Legacy: built-ins, Company-level, then the caller's own. Kept one release. */
    personas: { name: string; prompt: string; source: string }[];
}














export interface DashboardQuery {
    customer: string;
    user: string;
    job: string;
    id: string;
    share_id: string;
}
export interface UserRoleUpdate {
    user_id: string;
    platinum: boolean;
    ruby: boolean;
    admin: boolean;
}
/** A customer's budget team (#1523, goapi/pkg/types/budget_teams.go). */
export interface Team {
    id: string;
    customer: string;
    name: string;
    archived_at: number | null;
    created_by: string;
    created_at: number;
    /** The team's budget state now (annual budgets, migration 000145). Filled by GET /teams. */
    budget_state?: BudgetState;
    /** How many hidden (automated) member rows the team holds (#1563). */
    hidden_members?: number;
    /** Its own alert percentages (spend control 6b); null = the customer's. Manager-set. */
    alert_thresholds?: number[] | null;
    /** The people appointed over the team (000146). Sent by GET /teams and the managers routes. */
    managers?: TeamManagerView[];
    /** The team's budget in the customer's price; null before it starts. Sent by GET /teams. */
    budget?: TeamCardBudget | null;
    /** The live AutoCoder pipelines billed to the team (per-pipeline billing team). Sent by GET /teams. */
    billed_pipelines?: PipelineRef[];
}
/** A pipeline named in a list: the Teams page's "Bills these pipelines". */
export interface PipelineRef {
    id: string;
    job: string;
    system_name?: string;
    name: string;
}
/**
 * A user's budget team and AI level. team_id null is "No budget team".
 * hidden rows (the connector's service account) reach Managers only.
 */
export interface CustomerMember {
    customer: string;
    email: string;
    team_id: string | null;
    ai_level: number;
    hidden: boolean;
    updated_by: string;
    updated_at: number;
}
/**
 * One person of a customer (GET /admin/customers/:customer/people): on its
 * user list (via "customer") or only on one of its jobs (via "job", with the
 * job names in jobs).
 */
export interface CustomerPerson {
    id: string;
    email: string;
    name: string;
    roles: string;
    via: 'customer' | 'job';
    jobs: string[];
}
export interface TableAnalysisContext {
    table_path: string;
    table_name: string;
    display_name: string;
    analysis: string;
    /** The job the table belongs to and the filter it ran under (#1810). */
    job?: string;
    filter?: string;
}
export interface MultiTableAnalysisChatContext {
    table_analyses: TableAnalysisContext[];
    combined_report: string;
    /** The analysis profile versions the card read (#2014). */
    profiles?: AnalysisProfileRef[];
    /** "Based on the … analysis profile, version N.", written by goapi when it serves the card. */
    based_on?: string;
}
export interface MultiTableAnalysisProgress {
    total: number;
    completed: number;
    failed: number;
    current_table?: string;
    percent_done: number;
}
export interface MultiTableAnalysisConfig {
    global_filter?: string;
    user_context?: string;
    synthesis_user_context?: string;
    output_length?: string;
    section_name?: string;
    analysis_instructions?: string;
    synthesis_instructions?: string;
    /** Manual edit folded into the regeneration prompt (#1144). Transient
     *  per-run context — deliberately separate from synthesis_user_context so
     *  the "Settings changed" snapshot comparison stays clean. */
    edit_fold_in_context?: string;
    /** The dashboard filter each table ran under, by job (#1810). The server
     *  keeps only the jobs the card's tables use, trimmed, empties dropped;
     *  absent means every table ran unfiltered. */
    job_filters?: {[key: string]: string};
}
export interface MultiTableAnalysis {
    id: string;
    created_at: number;
    updated_at: number;
    multi_table_id: string;
    customer: string;
    job: string;
    user: string;
    persona: string;
    state: MultiTableAnalysisState;
    error?: string;
    config?: MultiTableAnalysisConfig;
    progress?: MultiTableAnalysisProgress;
    combined_report?: string;
    chat_context?: MultiTableAnalysisChatContext;
    data_latest_month?: string;
    data_previous_month?: string;
    validation_issues?: string;
}
export interface MultiTableAnalysisItem {
    id: string;
    created_at: number;
    updated_at: number;
    analysis_id: string;
    table_path: string;
    table_name: string;
    display_name: string;
    job?: string;
    state: MultiTableAnalysisItemState;
    error?: string;
    markdown?: string;
    analysis?: string;
    latest_month?: string;
    previous_month?: string;
    validation_issues?: string;
}




export interface CustomPersona {
    name: string;
    prompt: string;
}
export interface ConfigData {
    table_view_mode: string;
    table_analysis_prompt: string;
    method_prompt: string;
    theme_ai_extract_prompt: string;
    theme_ai_match_prompt: string;
    exec_report_table_analysis_prompt: string;
    exec_report_section_synthesis_prompt: string;
    custom_personas: CustomPersona[];
    auto_update_enabled: boolean;
    include_side_label?: boolean;
    autocoder_carbon_labels: string[];
    autocoder_model?: string;
    stats_reviewer_name?: string;
    stats_reviewer_contact?: string;
    stats_reviewer_team?: string;
    stats_reviewer_email?: string;
    table_view_settings?: TableViewSettingsData;
    brand_palette?: {[key: string]: BrandPaletteEntry};
}

export interface ConfigFieldDefinition {
    name: string;
    type: ConfigFieldType;
    strategy: ConfigFieldMergeStrategy;
    separator?: string;
    label: string;
    description?: string;
    placeholder?: string;
    placeholder_by_config_type?: {[key: number]: string};
    tab: string;
    visible_at: number[];
    order: number;
    multiline?: boolean;
    rows?: number;
    enum_options?: string[];
    component?: string;
    requires_root?: boolean;
}
export interface ConfigTabDefinition {
    id: string;
    label: string;
    order: number;
    help_video_url?: string;
    advanced?: boolean;
}
export interface ConfigSchema {
    tabs: ConfigTabDefinition[];
    fields: {[key: string]: ConfigFieldDefinition};
}
export interface Config {
    id: string;
    config_type: ConfigType;
    customer: string;
    job: string;
    folder_path: string;
    table_name: string;
    data?: ConfigData;
    created_at: number;
    updated_at: number;
}
export interface ListConfigsQuery {
    config_type: ConfigType;
    customer: string;
    job: string;
    folder_path: string;
    table_name: string;
}
export interface ConfigReference {
    field_name: string;
    value?: any;
    source_entity?: ListConfigsQuery;
    source_config?: Config;
}
export interface MergedConfigFieldDetail {
    strategy: ConfigFieldMergeStrategy;
    sources: ConfigReference[];
}
export interface MergedConfigResult {
    data?: ConfigData;
    fields: {[key: string]: MergedConfigFieldDetail};
}
export interface Prompt {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    name: string;
    description: string;
    prompt_type: string;
    category: string;
    pillar: string;
    section: string;
    tables: string[];
    content: string;
    created_by: string;
}
export interface BrandTheme {
    id: string;
    customer: string;
    user: string;
    name: string;
    palette: {[key: string]: BrandPaletteEntry};
    created_at: number;
    updated_at: number;
    promoted_at?: number;
    promoted_by?: string;
    modified_by?: string;
}
export interface BrandThemeHistoryEntry {
    id: string;
    theme_id: string;
    customer: string;
    action: 'create' | 'update' | 'delete' | 'promote' | 'demote' | string;
    actor: string;
    at: number;
    theme_name: string;
    name_before?: string;
    palette_before?: {[key: string]: BrandPaletteEntry};
    palette_after?: {[key: string]: BrandPaletteEntry};
}
export interface DashboardShareResponse {
    share_id: string;
    access_level: string;
    enabled: boolean;
}
export interface AlertTableRef {
    job: string;
    folder_path: string;
    filename: string;
    display_name: string;
    range?: TableRange;
}
export interface NaturalLanguageRuleConfig {
    rule_text: string;
    context?: string;
}
export interface AlertCheck {
    script: string;
    summary: string;
    script_hash: string;
    tested_hash: string;
    runner_session_id: string;
    test_session_id: string;
    setup_session_id: string;
}
/* Alert source kinds (Adam, 11 Oct 2026) — manually mirrored from goapi/pkg/types/alerts.go. */
export type AlertSourceKind = 'table' | 'query' | 'event'
export type AlertEventType = 'job_import_completed' | 'job_import_failed' | 'import_batch_failed' | 'import_batch_truncated'
export interface AlertQuerySource {
    question: string;
}
export interface AlertEventSource {
    type: AlertEventType;
    pipeline_id?: string;
}
// What an alert watches. The kind is fixed when the alert is created. A rule
// saved before source kinds existed has none: read it as a table alert on
// tables[0].job (utils/alertSources.ts alertSourceOf).
export interface AlertSource {
    kind: AlertSourceKind;
    job: string;
    query?: AlertQuerySource;
    event?: AlertEventSource;
}
/* Alert schedules (alerts round, 12 Oct 2026) — manually mirrored from goapi/pkg/types/alerts.go.
 * Three shapes with one time of day, in the rule's IANA time zone; no cron. */
export type AlertEvery = 'daily' | 'weekly' | 'monthly'
export interface AlertSchedule {
    every: AlertEvery;
    /** "HH:MM", 24h. */
    at: string;
    /** Weekly only: 0 Sunday … 6 Saturday. */
    weekday?: number;
    /** Monthly only: 1..31; above the month's length runs on its last day. */
    day?: number;
    /** IANA zone; the server defaults it to Europe/London. */
    timezone: string;
}
export interface AlertRuleConfig {
    rule_type: string;
    natural_language?: NaturalLanguageRuleConfig;
    check?: AlertCheck;
    source?: AlertSource;
    /** When a table or question alert runs; absent on an event alert. */
    schedule?: AlertSchedule;
}
export interface AlertRule {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    user: string;
    name: string;
    status: AlertRuleStatus;
    tables: AlertTableRef[];
    config: AlertRuleConfig;
    /** Colleagues notified with the owner when it fires: lowercase emails, never the owner. goapi always sends it; optional so a fixture without it reads as none. */
    recipients?: string[];
    last_evaluated_at: number;
    last_triggered_at: number;
}
// AlertRuleWithLatest pairs an alert rule with its most recent evaluation of
// ANY trigger type (including test and running) — "what last happened",
// which is what the Alerts list's "Last result" column shows. It is nil for
// a rule that has never run (T18).
export interface AlertRuleWithLatest extends AlertRule {
    latest_evaluation?: AlertEvaluation;
}
export interface AlertEvaluationData {
    table_snapshots: {[key: string]: string};
    llm_response: string;
    reasoning: string;
    fired: boolean;
    fire_message: string;
    fire_values?: {[key: string]: number};
    exit_code: number;
    stdout: string;
    stderr: string;
    timed_out: boolean;
    /** Event evaluations (trigger_type event) only: "<type>:<row id>". */
    event_id?: string;
    event_type?: string;
    event_ref?: string;
}
export interface AlertEvaluation {
    id: string;
    created_at: number;
    alert_rule_id: string;
    trigger_type: string;
    result: AlertEvaluationResult;
    error?: string;
    data?: AlertEvaluationData;
}
export interface DashboardSubscriber {
    id: string;
    dashboard_id: string;
    customer: string;
    job: string;
    user_email: string;
    added_by: string;
    created_at: number;
    unsubscribed_at?: number;
}
// A kind of job data change a re-index notice names (types.JobDataChange*).
export type JobDataChangeKind = 'data_upload' | 'tables' | 'variables';
export interface UserNotificationPayload {
    dashboard_id: string;
    dashboard_name: string;
    share_url?: string;
    sender: string;
    message?: string;
    // Present only on `agent_question` rows (#1347 item 10); dashboard rows
    // leave both empty. share_url carries the path to the session.
    session_id?: string;
    session_title?: string;
    // Present only on `alert_triggered` rows (T14); dashboard/agent rows
    // leave these empty. share_url carries the path to the alert.
    alert_rule_id?: string;
    alert_name?: string;
    // The alert's owner, on every alert_triggered row (a recipient's row
    // too), so the bell can say whose alert it is.
    alert_owner?: string;
    // Present only on `ai_access_requested` rows (#1537 PR D). sender is the
    // requester's email, message their optional note, share_url the path to
    // User management.
    requester_level?: number;
    feature?: string;
    feature_label?: string;
    // Present only on `budget_threshold` rows (access audit T6): a team
    // crossed threshold% of its budget. Amounts are pounds, the customer's
    // price (spend control PR 5); share_url is the path to AI budgets.
    team_name?: string;
    threshold?: number;
    spent_gbp?: number;
    remaining_gbp?: number;
    allocated_gbp?: number;
    // How the customer read money when the notice was written (spend control
    // PR 6d); absent on older notices, which read as pounds.
    display_unit?: BillingDisplayUnit;
    credit_value_gbp?: number;
    // Present only on `budget_year_end` rows (annual budgets PR D), beside
    // team_name: end_at is the year's exclusive end (epoch ms), days_left the
    // whole days to it (absent once it has ended), year_end the notice's kind,
    // and ai_off whether the customer's switch was on, so the team's AI stops.
    end_at?: number;
    days_left?: number;
    year_end?: 'ending_30' | 'ending_7' | 'ended';
    ai_off?: boolean;
    // Present only on `analysis_digest` rows (#1652): the previous UTC day's
    // flagged advanced analyses. period_start/period_end are epoch ms of that
    // day; methods are labels; share_url is the Stats review page for it.
    flag_count?: number;
    people?: number;
    methods?: string[];
    period_start?: number;
    period_end?: number;
    // Present only on `release_pending` rows: when the release restarts the
    // app, epoch ms.
    starts_at?: number;
    // Present only on `guide_invite` rows (guided conversations, 28 Oct 2026):
    // share_url is the path /guided/<customer>/<response_id>, sender the
    // inviting Manager. The server sends guide_id and guide_title;
    // response_id is read when present, else taken from share_url.
    response_id?: string;
    guide_id?: string;
    guide_title?: string;
    // Present only on `job_reindex_needed` rows (#2013): the job whose search
    // index is behind its data, the kinds that changed (data_upload, tables,
    // variables, in that order), the newest change and, once a later build
    // covered them, when it completed. Times are epoch ms.
    job?: string;
    changes?: JobDataChangeKind[];
    changed_at?: number;
    resolved_at?: number;
}
export interface UserNotification {
    id: string;
    created_at: number;
    customer: string;
    recipient: string;
    type: string;
    payload: UserNotificationPayload;
    read_at?: number;
}
// Hand-written types (not auto-generated from Go)

export interface VariableImportStats {
    name: string;
    cd_size: number;
    met_size: number;
    total_lines: number;
    coded_lines: number;
    missing_lines: number;
    has_data: boolean;
    verified: boolean;
    tabulation_ok: boolean;
    retries: number;
}
export interface ImportResult {
    variables_created: string[];
    variables_skipped: string[];
    variable_stats: VariableImportStats[];
    warnings: string[];
    cases_processed: number;
    total_cases: number;
    blob_cache_cleared: boolean;
    carbon_cache_cleared: boolean;
}

export interface SharedDashboardResponse {
    access_level: string;
    dashboard?: Dashboard;
    name?: string;
    requires_password?: boolean;
    requires_login?: boolean;
    customer?: string;
    dashboard_id?: string;
    type?: string;
}

export type AlertRuleStatus = 'active' | 'paused' | 'archived'
export type AlertEvaluationResult = 'running' | 'triggered' | 'not_triggered' | 'error'
export type AlertRuleType = 'natural_language'
/* Programme tracker (render model + admin rows) — manually mirrored from goapi/pkg/types/programme_tracker.go */
export interface TrackerBranding {
    customerName: string;
    logoUrl: string;
    primaryColor: string;
    accentColor: string;
}
export interface TrackerSummarySection {
    name: string;
    doneStatus: string;
    done: number;
    total: number;
}
export interface TrackerSummary {
    sections: TrackerSummarySection[];
    overallPct: number;
}
export interface TrackerLead {
    bp: string;
    client: string;
}
export interface TrackerStep {
    index: number;
    name: string;
    state: string;
}
export interface TrackerStepInfo {
    name: string;
    description: string;
}
export interface TrackerNote {
    text: string;
    author: string;
    date: string;
}
export interface TrackerSectionView {
    id: string;
    name: string;
    description: string;
    lead: TrackerLead;
    stepLegend: TrackerStepInfo[];
    items: TrackerItemView[];
}
export interface TrackerItemView {
    id: string;
    title: string;
    number: number | null;
    jobId: string;
    poc: string;
    bpLead: string;
    status: string;
    done: boolean;
    steps: TrackerStep[];
    objective: string;
    scope: string;
    acceptanceCriteria: string;
    body: string;
    uatDate: string;
    acceptedDate: string;
    latestNote: TrackerNote;
    updates: TrackerNote[];
}
export interface TrackerLeadershipRow {
    stream: string;
    role: string;
    bp: string;
    client: string;
}
export interface TrackerChangeLogEntry {
    date: string;
    change: string;
    author: string;
    item: string;
}
export interface TrackerReference {
    vision: string;
    leadership: TrackerLeadershipRow[];
    changeLog: TrackerChangeLogEntry[];
}
export interface TrackerState {
    slug: string;
    title: string;
    subtitle: string;
    customer: string;
    branding: TrackerBranding;
    lastUpdated: number;
    summary: TrackerSummary;
    sections: TrackerSectionView[];
    reference: TrackerReference;
}

// ---- Admin rows (tracker → sections → items → updates) ----

export interface ProgrammeTracker {
    id: string;
    slug: string;
    customer: string;
    title: string;
    subtitle: string;
    branding: TrackerBranding;
    reference: TrackerReference;
    enabled: boolean;
    /** Shown only to Managers and people with the Finance view (migration 000154). */
    financeOnly: boolean;
    createdAt: number;
    updatedAt: number;
}
export interface ProgrammeTrackerSection {
    id: string;
    trackerId: string;
    name: string;
    description: string;
    bpLead: string;
    clientLead: string;
    steps: TrackerStepInfo[];
    doneStatus: string;
    sortOrder: number;
    createdAt: number;
    updatedAt: number;
}
export interface ProgrammeTrackerItem {
    id: string;
    sectionId: string;
    title: string;
    number: number | null;
    jobId: string;
    poc: string;
    bpLead: string;
    status: string;
    currentStep: number;
    objective: string;
    scope: string;
    acceptanceCriteria: string;
    body: string;
    uatDate: string;
    acceptedDate: string;
    sortOrder: number;
    createdAt: number;
    updatedAt: number;
}
export interface ProgrammeTrackerUpdate {
    id: string;
    itemId: string;
    text: string;
    author: string;
    date: string;
    createdBy: string;
    createdAt: number;
    updatedAt: number;
}
export interface ProgrammeTrackerItemContent extends ProgrammeTrackerItem {
    updates: ProgrammeTrackerUpdate[];
}
export interface ProgrammeTrackerSectionContent extends ProgrammeTrackerSection {
    items: ProgrammeTrackerItemContent[];
}
export interface ProgrammeTrackerContent {
    sections: ProgrammeTrackerSectionContent[];
}

// DashboardShareView records a single open/access of a shared dashboard link.
export interface DashboardShareView {
    id: string;
    created_at: number;
    share_id: string;
    dashboard_id: string;
    customer: string;
    ip_address?: string;
    user_agent?: string;
    access_type: string;
}

export interface DashboardShareViewQuery {
    share_id?: string;
    customer?: string;
    start_time?: number;
    end_time?: number;
    limit?: number;
    offset?: number;
}

export interface DashboardShareViewListResult {
    views: DashboardShareView[];
    total_count: number;
    limit: number;
    offset: number;
}

// ===================================================================// ThemeAI Wave 1 (hand-maintained — mirrors goapi/pkg/types/themeai_tasks.go
// and goapi/pkg/server/themeai_tasks.go. Do not regenerate this file; append
// new interfaces by hand per docs/frontend-architecture.md convention.)
// ===================================================================
export type ThemeAIVisibility = 'exec' | 'user'

export type ThemeAITaskStatus = 'draft' | 'active' | 'archived'

export type ThemeAIResponseScope = 'new_only' | 'full_refresh'

export type ThemeAIRunStatus = 'pending' | 'running' | 'completed' | 'failed'

export type ThemeAIDataSourceType = 'job_variable' | 'upload'

export interface ThemeAIJobVariableSource {
    job: string;
    variable_name: string;
    folder_path?: string;
    question?: string;
}

export interface ThemeAIUploadSource {
    file_name: string;
    blob_path?: string;
    text_column?: string;
    id_column?: string;
    row_count?: number;
}

export interface ThemeAIDataSource {
    type: ThemeAIDataSourceType;
    job_variable?: ThemeAIJobVariableSource;
    upload?: ThemeAIUploadSource;
}

export interface ThemeAITask {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    job: string;
    name: string;
    owner: string;
    visibility: ThemeAIVisibility;
    status: ThemeAITaskStatus;
    starred: boolean;
    data_source?: ThemeAIDataSource;
    // (T7) `pipeline_id` is gone — a task's membership is its record pool and
    // its runs drive the LLM queue themselves, so there is no backing pipeline.
    code_frame_id?: string;
    code_frame_version?: number;
    labels?: {[key: string]: string};
    // What the researcher told ThemeAI about the study; the agent and every run read it.
    study_context?: string;
    // Server-owned counter bumped on every data-source replacement. PUT never
    // writes it. "Current run" = run.data_revision == task.data_revision (plus
    // the code frame match) — see ThemeAIRun.data_revision.
    data_revision: number;
    // Transient: populated only by GET /tasks/:taskId (CountThemeAITaskRecords).
    pool_size?: number;
}

export interface ThemeAITheme {
    id: string;
    code: number;
    name: string;
    assignment_explanation?: string;
    group_id?: string;
    order: number;
}

export interface ThemeAIGroup {
    id: string;
    name: string;
    order: number;
}

export interface ThemeAICodeFrameVersion {
    id: string;
    code_frame_id: string;
    version: number;
    created_at: number;
    created_by: string;
    change_note?: string;
    themes: ThemeAITheme[];
    groups?: ThemeAIGroup[];
}

export interface ThemeAICodeFrame {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    job: string;
    name: string;
    owner: string;
    visibility: ThemeAIVisibility;
    archived: boolean;
    latest_version: number;
    labels?: {[key: string]: string};
    /** Set on the built-in company-level frames every customer sees (#1492); they are read-only. */
    standard?: 'sentiment' | 'emotion';
    versions?: ThemeAICodeFrameVersion[];
}

export interface ThemeAIRun {
    id: string;
    run_number: number;
    task_id: string;
    customer: string;
    job: string;
    user: string;
    response_scope: ThemeAIResponseScope;
    code_frame_id?: string;
    code_frame_version?: number;
    response_count: number;
    token_estimate: number;
    token_actual: number;
    // Our cost, in dollars: served to a Manager only (#1930).
    cost?: number;
    include_explanations: boolean;
    include_sentiment: boolean;
    include_emotion: boolean;
    status: ThemeAIRunStatus;
    created_at: number;
    completed_at?: number;
    // Stamped from the task's data_revision at creation time. "Current run" =
    // run.data_revision == task.data_revision (plus the code frame match).
    data_revision: number;
    // The controller's durable state (E2 T1/T3). `phase` is "" for a run no
    // controller owns; `is_test` marks a sampled preview run (T4) and has no
    // omitempty on the Go side, so it is always on the wire.
    phase?: string;
    awaiting_request_ids?: string[];
    error?: string;
    is_test: boolean;
    // Transient (gorm:"-") — filled in by the runs-list/single-run/test-run
    // handlers from one grouped query over themeai_run_records (themeai-ui-pass
    // T1, Matt: "if there's 1,045, you need to know it's done 422").
    records_total?: number;
    records_settled?: number;
    // How many covered responses the run could not code: the content filter
    // blocked them, or the model could not produce a result (#1596).
    records_failed?: number;
    // The model calls the current phase awaits, and how many have finished;
    // set while a run is running (results only land at the end).
    requests_total?: number;
    requests_done?: number;
    // The junk check this run applied (#1891): the screening, what the user
    // chose, and how many answers that touched (coded as junk, or dropped).
    screening_id?: string;
    junk_decision?: ThemeAIJunkDecision;
    junk_count?: number;
    // The personal data flag this run applied (#494): what the user chose,
    // and how many answers it coded to 98 as well as their themes.
    personal_data_decision?: ThemeAIPersonalDataDecision;
    personal_data_count?: number;
}

// GET /themeai/:customer/:job/standard-frames — ThemeAI's built-in
// sentiment and emotion code lists (Matt: when sentiment/emotion is switched
// on, show "our three sentiments and our descriptions of those").
export interface ThemeAIStandardCode {
    code: string;
    text: string;
    description: string;
}
export interface ThemeAIStandardFrames {
    sentiment: ThemeAIStandardCode[];
    emotion: ThemeAIStandardCode[];
    // The framework descriptions the model is given with each (#1523).
    sentiment_description?: string;
    emotion_description?: string;
    // The customer has switched that pass off (#1234 SKY-20); a run that asks
    // for it is refused.
    sentiment_off?: boolean;
    emotion_off?: boolean;
}

// Tier-grouped list envelopes returned by GET /themeai/:customer/:job/tasks
// and GET /themeai/:customer/:job/code-frames (spec §3.2 / §4.2).
export interface ThemeAITaskListResponse {
    exec: ThemeAITask[];
    mine: ThemeAITask[];
    colleagues: ThemeAITask[];
}

export interface ThemeAICodeFrameListResponse {
    exec: ThemeAICodeFrame[];
    mine: ThemeAICodeFrame[];
    colleagues: ThemeAICodeFrame[];
}

export interface CreateThemeAITaskRequest {
    name: string;
    visibility?: ThemeAIVisibility;
    data_source?: ThemeAIDataSource;
    code_frame_id?: string;
    code_frame_version?: number;
    labels?: {[key: string]: string};
    study_context?: string;
}

export interface CreateThemeAICodeFrameRequest {
    name: string;
    visibility?: ThemeAIVisibility;
    themes?: ThemeAITheme[];
    groups?: ThemeAIGroup[];
    labels?: {[key: string]: string};
}

export interface UpdateThemeAICodeFrameRequest {
    name?: string;
    visibility?: ThemeAIVisibility;
    archived?: boolean;
    labels?: {[key: string]: string};
}

export interface CreateThemeAICodeFrameVersionRequest {
    themes: ThemeAITheme[];
    groups?: ThemeAIGroup[];
    change_note?: string;
}

export interface CreateThemeAIRunRequest {
    response_scope: ThemeAIResponseScope;
    code_frame_id?: string;
    code_frame_version?: number;
    response_count?: number;
    token_estimate?: number;
    include_explanations?: boolean;
    include_sentiment?: boolean;
    include_emotion?: boolean;
}

// ThemeAI estimate and result shapes. The frontend tolerates a temporary 404
// while a mixed-version deployment rolls from backend to frontend.

// POST /themeai/:customer/:job/tasks/:taskId/estimate (Wave 1C)
export interface ThemeAIEstimateResponse {
    response_count: number;
    word_count: number;
    estimated_tokens: number;
    // In pounds. Our rate-card cost for a Manager, the customer's price
    // (cost at its markup) for anyone else (spend control PR 5).
    estimated_cost: number;
    // Always "GBP" since PR 6f (it was "USD" while the quota gate supplied
    // remaining_budget).
    currency: 'GBP';
    // *float64 on the Go side: the caller's team budget left, as price in
    // pounds (PR 6f). Null for a Manager and for anyone no team budget
    // applies to (no team, the customer's switch off). 0 for a team with no
    // budget: the run would be refused (no_budget).
    remaining_budget: number | null;
    human_comparison: string;
    human_cost_gbp: number;
    // Working days a human coder would take (response_count / 250), rounded
    // to one decimal with a 0.5-day floor.
    human_days: number;
    // How the customer reads money, and what one credit is worth in pounds
    // (spend control PR 6d). Sent to everyone.
    display_unit: BillingDisplayUnit;
    credit_value_gbp: number;
    // Set when a non-Manager's estimated_cost is a fixed-mode list price:
    // units × the item's credits × the credit value ("11 × 100 responses").
    units?: number;
    unit_label?: string;
    // Answers a saved junk decision keeps out of this estimate: dropped ones
    // and ones coded as junk without a model call (#1891).
    junk_excluded?: number;
    junk_decision?: ThemeAIJunkDecision;
}

// POST /themeai/:customer/:job/uploads/inspect (multipart "file",
// task-independent) — column preview shown before UploadThemeAITaskData.
export interface ThemeAIUploadColumn {
    name: string;
    index: number;
    samples: string[];
    avg_length: number;
    non_empty: number;
}

export interface ThemeAIUploadInspection {
    format: 'csv' | 'xlsx';
    row_count: number;
    columns: ThemeAIUploadColumn[];
    suggested_text_column: string;
    suggested_id_column: string;
}

// GET /themeai/:customer/:job/tasks/:taskId/runs/:runNumber/records
// (theme filter is the chart drill-through: clicking a theme bar filters the
// response list).
export interface ThemeAIRunRecordTheme {
    code: string;
    name: string;
    matching_text?: string;
    // Why the theme was assigned; present when the run explained its assignments.
    explanation?: string;
    // This theme's sentiment and emotion labels. They belong to the theme:
    // one response can be Negative on one theme and Positive on another.
    sentiment?: string;
    emotion?: string;
}

export interface ThemeAIRunRecordRow {
    record_id: string;
    interview_id: string;
    source_text: string;
    themes: ThemeAIRunRecordTheme[];
    // Why the run could not code this response (#1596).
    error?: string;
}

export interface ThemeAIRunRecordsPage {
    total: number;
    records: ThemeAIRunRecordRow[];
}

export interface ThemeAIResultDistributionItem {
    id?: string;
    // The raw match code; pass it as the `theme` filter to .../records.
    code?: string;
    name: string;
    count: number;
    pct: number;
}

// GET /themeai/:customer/:job/tasks/:taskId/runs/:runNumber/results (Wave 1C)
export interface ThemeAIRunResultsResponse {
    themes: ThemeAIResultDistributionItem[];
    sentiment?: ThemeAIResultDistributionItem[];
    emotion?: ThemeAIResultDistributionItem[];
    total_records: number;
}

// POST /themeai/:customer/:job/tasks/:taskId/write-variable (Wave 2a, #956) —
// task-level write-back: publishes EVERY currently-coded record for the task
// (across all runs) as a new multi-response variable in the job. Mirrors
// goapi/pkg/server/themeai_writeback.go's WriteThemeAITaskVariableRequest.
export interface WriteThemeAITaskVariableRequest {
    variable_name?: string;
    overwrite?: boolean;
}

// Response shape shared by the task-level and run-level write-back endpoints
// (goapi WriteThemeAIVariableResponse).
export interface WriteThemeAIVariableResponse {
    message: string;
    variable: string;
    folder: string;
    customer: string;
    job: string;
    codes: number;
    cases: number;
    cases_coded: number;
    // The starter table made for the variable (#1484), as the Tables route's
    // `table` param: Tables/User/<email>/themeai/<variable>. Absent when the
    // table could not be made; table_error then says why.
    table?: string;
    table_error?: string;
    // The sentiment and emotion variables written beside the themes one when
    // the coded answers carry them (#1594); absent when they do not.
    sentiment?: ThemeAICompanionVariable;
    emotion?: ThemeAICompanionVariable;
}

// A sentiment or emotion variable written beside the themes variable (#1594),
// with its own starter table (goapi ThemeAICompanionVariable). error says why
// it was not written; table_error why its table was not made.
export interface ThemeAICompanionVariable {
    variable: string;
    codes: number;
    cases_coded: number;
    table?: string;
    table_error?: string;
    error?: string;
}

// Gen AI wizard Path B "Help me write this" (#970/#1048; D4 resolved
// direct-LLM 2026-08-14). Hand-mirrors goapi/pkg/types/types.go
// GenAIInstructionsSource / GenAIInstructionsContext — the body of
// POST /dashboards/:customer/genai-instructions/initial. Unlike
// DashboardInsightsContext this is assembled by the FRONTEND (the wizard may
// be configuring a card on a never-saved dashboard). `customer` is stamped
// from the URL server-side, so the frontend never sends it.
export interface GenAIInstructionsSource {
    name: string;
    /** Job-relative path, e.g. "Tables/Exec/Awareness/TC Spon Aware All Prospect". */
    path?: string;
}
export interface GenAIInstructionsContext {
    customer?: string;
    job?: string;
    /** Step 0 card title. */
    title?: string;
    /** Step 1 selection. */
    sources: GenAIInstructionsSource[];
    /** Current Step 2 field content (scaffold or user-edited, incl. any guided-toggle sentence). */
    instructions_draft?: string;
}

// ---- Positional Select Data for the chart widget (#968 Obs 10/11) ----
// Declaration merge onto the TableGraphSelection interface declared earlier in
// this file (this file is append-only — do not edit the original in place).
// Mirrors RowPositions/ColumnPositions on TableGraphSelection in
// goapi/pkg/types/types.go.
export interface TableGraphSelection {
    /**
     * Rows selected by POSITION (0-based side-vec index), not by name —
     * confirmed decision, consistent with Carbon. A slot always renders
     * whatever occupies that position regardless of label changes; absent or
     * empty means all rows, refreshing with whatever the table now holds.
     * Supersedes `rows` (legacy name form, still readable) for new writes.
     */
    row_positions?: number[];
    /**
     * Positional form for columns, same semantics. Takes precedence over
     * `columns` and `pinned_columns` when set — a positional pick cannot
     * drift with new waves, so it needs no pin.
     */
    column_positions?: number[];
}

// ---- Table widget structural labels toggle (#969 Obs 15) ----
// Declaration merge onto the TableViewConfig interface declared earlier in
// this file (this file is append-only — do not edit the original in place).
// Mirrors HideStructuralLabels on TableViewConfig in goapi/pkg/types/types.go.
export interface TableViewConfig {
    /**
     * Hide the structural label columns — the nested side group columns
     * carrying filter/question labels — from the widget's DISPLAY only.
     * Independent of row/column data selection; the underlying table
     * structure, spec, and Carbon data are untouched. Applied by
     * stripRowGroupLabels in ../utils/tableViewConfig.ts.
     *
     * SUPERSEDED by the two scoped toggles below (#969 comment 2 item 4),
     * still read as the ROW side only — that is all it ever hid.
     */
    hide_structural_labels?: boolean;
    /**
     * Draw the row-side group-label columns. Absent means a widget saved
     * before this existed: it keeps showing them. False is an explicit hide,
     * which is what a newly configured widget is stamped with (the toggle
     * defaults OFF). Mirrors ShowRowGroupLabels in goapi/pkg/types/types.go.
     */
    show_row_group_labels?: boolean;
    /** The column-side mirror. Same absent/false distinction. */
    show_column_group_labels?: boolean;
}

// ---- Table widget multi-band Data Type (#969 comment 1 item 2) ----
// Declaration merge onto the TableGraphWidgetData interface declared earlier
// in this file. Mirrors DataTypes in goapi/pkg/types/types.go.
export interface TableGraphWidgetData {
    /**
     * The TABLE widget's band set — a table can show Frequencies, Column %
     * and Row % at once, so its Data Type control is checkboxes rather than
     * the chart's single-select dropdown (the chart still reads `data_type`).
     * At least one band is always selected. Empty or absent falls back to
     * `data_type` read as a one-element set, so widgets saved before this
     * render exactly as they did. Display level only.
     */
    data_types?: string[];
}

/** A named, repeatable "show me around" agenda (#1323). Steps are in tour order. */
export interface HelpTour {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    name: string;
    agenda: string;
    steps: HelpTourStep[];
    sort_order: number;
    created_by: string;
    updated_by: string;
}
export interface HelpTourStep {
    /** A navigate_to_page key, or empty to stay where you are. */
    page: string;
    /** Exact text to put in the composer and send, for the agent to answer. */
    type: string;
    /** What Douglas explains or shows there. */
    say: string;
    /** System context PR B: the registry feature, "<section>/<feature>". Optional; older tours have none. */
    feature?: string;
    /** System context PR B: the on-screen label of the control the Help pane outlines. */
    control?: string;
    /** Help pane live tours: a page tool the pane runs when the step is entered, its args (a value may be {"$pick": name}) and the "Next: …" line. */
    action?: { tool: string; args?: Record<string, unknown>; label: string };
}

/** A customer's edited version of one help section (#1323); a missing row means the shipped default applies. */
export interface HelpSectionRecord {
    id: string;
    created_at: number;
    updated_at: number;
    customer: string;
    key: string;
    title: string;
    nav_page: string;
    about: string;
    elements: HelpSectionElement[];
    steps: string[];
    sort_order: number;
    updated_by: string;
}
export interface HelpSectionElement {
    /** The registry feature key it came from (System context, 13 Oct); absent on elements saved before. */
    key?: string;
    name: string;
    what: string;
    how: string;
}

export interface ConstructLevelItem {
    label: string;
    filter: string;
}
export interface ConstructLevel {
    variable: string;
    items: ConstructLevelItem[];
}
export interface ConstructItem {
    code: number;
    label: string;
    filter: string;
}
export interface ConstructDefinition {
    name: string;
    description: string;
    kind: string;
    items: ConstructItem[];
    levels?: ConstructLevel[];
}
export interface ConstructLineError {
    index: number;
    message: string;
}
export interface ConstructValidateResponse {
    ok: boolean;
    lineErrors: ConstructLineError[];
    errors: string[];
    sources: string[];
}
export interface ConstructPreviewCount {
    code: number;
    label: string;
    count: number;
}
export interface ConstructPreviewResponse {
    ok: boolean;
    base: number;
    counts: ConstructPreviewCount[];
    lineErrors: ConstructLineError[];
}
export interface ConstructJobRequest {
    customerName: string;
    jobName: string;
    definition: ConstructDefinition;
}
export interface ConstructSaveRequest {
    customerName: string;
    jobName: string;
    definition: ConstructDefinition;
    writeGrant: string;
}
export interface ConstructSaveResponse {
    ok: boolean;
    caseCount: number;
    sources: string[];
    errors: string[];
}
export interface ConstructRebuildRequest {
    customerName: string;
    jobName: string;
    variables: string[];
    fromCase: number;
    writeGrant: string;
}
export interface JobConstruct {
    customer: string;
    job: string;
    name: string;
    kind: string;
    description: string;
    folder: string;
    definition: ConstructDefinition;
    sources: string[];
    createdBy: string;
    updatedBy: string;
    createdAt: Time;
    updatedAt: Time;
    lastBuiltAt?: Time;
    lastBuildStatus?: string;
    lastBuildError?: string;
}
export interface ConstructDependentOutcome {
    name: string;
    status: string;
    error?: string;
}
export interface ConstructSaveResult extends JobConstruct {
    dependents?: ConstructDependentOutcome[];
}
export interface JobConstructEvent {
    id: number;
    customer: string;
    job: string;
    name: string;
    action: string;
    actor: string;
    before?: JobConstruct;
    after?: JobConstruct;
    detail?: string;
    createdAt: Time;
}
export interface SavPlannedCode {
    code: number;
    label: string;
}
export interface SavPlannedVariable {
    sourceName: string;
    label: string;
    type: string;
    codeStrategy: string;
    codes: SavPlannedCode[];
    isBlended: boolean;
    isWeight: boolean;
}
export interface SavInspectResponse {
    caseCount: number;
    weightVariable?: string;
    variables: SavPlannedVariable[];
    warnings: string[];
    errors: string[];
    /** Plain facts about ordinary data (no action needed); absent on plans stored before notes existed. */
    notes?: string[];
}
// AI access levels (#1537) — hand-written, like everything here. Mirrors
// goapi/pkg/aiaccess and goapi/pkg/types/budget_teams.go.
export type AIAccessFeature =
    | 'tables_insights'
    | 'general_chat'
    | 'dashboard_insights'
    | 'genai_cards'
    | 'help_me_write'
    | 'dashboard_generate'
    | 'themeai_explore'
    | 'agent_sessions'
    | 'alert_create'
    | 'voice'
    | 'themeai_run'
    | 'autocoder'
    // The Help pane (System context PR B): level 1, free to every team.
    | 'help'
    // Guided conversations (28 Oct 2026): the invitation is the grant, so level 1.
    | 'guided_conversation';
export interface AIAccessFeatureInfo {
    feature: AIAccessFeature;
    level: number;
    label: string;
    // #1226: a batch feature stops at the visible team budget, an interactive
    // one runs on into the team's headroom. A free one (the Help pane) meets no budget.
    kind?: 'batch' | 'interactive' | 'free';
}
// #1226 — a Realm admin a refusal names. name is empty when licensing holds
// only the email.
export interface AIRealmAdmin {
    email: string;
    name: string;
}
// A team's budget state (annual budgets, migration 000145): "none" never had
// a budget year, "scheduled" its year starts later, "active" a year covers
// now, "ended" its year ended and no next one has begun.
export type BudgetState = 'none' | 'scheduled' | 'active' | 'ended';
// #1226 — the caller's team budget on GET /ai-access/:customer/me. Present
// only when a budget applies; headroom is never shown.
export interface MyAIBudget {
    team_name: string;
    // No budget year covers now (state none, scheduled or ended): with the
    // switch on, every AI feature is refused (reason no_budget, budget_ended
    // or budget_not_started), and both exhausted flags are true.
    no_budget: boolean;
    // The team's budget state. starts_at is the current year's start, or the
    // next year's when scheduled; ends_at the current year's end
    // (exclusive), or that of the year that ended. Epoch ms; null when none.
    state?: BudgetState;
    starts_at?: number | null;
    ends_at?: number | null;
    // The customer's price, the figure the gate decides on (spend control PR 6a).
    remaining_gbp: number;
    // remaining_gbp ÷ the customer's credit value.
    remaining_credits: number;
    // How the customer reads money.
    unit: BillingDisplayUnit;
    // Share of the team's allocation used, spent ÷ allocated × 100 to one place
    // (a ratio of price figures; can pass 100 in the headroom). Drives the
    // page-top banner's 90% warning.
    pct: number;
    exhausted: { batch: boolean; interactive: boolean };
}
// Spend control PR 6a (migration 000142): how a customer is billed. "fixed"
// charges from a price list in credits (PR 6c).
export type BillingMode = 'metered' | 'fixed';
export type BillingDisplayUnit = 'gbp' | 'credits';
export interface MyAIAccess {
    customer: string;
    level: number;
    enforced: boolean;
    source: 'agent' | 'manager' | 'service_account' | 'switch_off' | 'no_team' | 'member';
    features: AIAccessFeatureInfo[];
    /** The caller's team, switch on or off; absent when they are in none. */
    team_name?: string;
    admins?: AIRealmAdmin[];
    budget?: MyAIBudget;
    /** The managers of the caller's team, switch on or off; [] for an agent or someone in no team. */
    team_managers?: AIRealmAdmin[];
    /** Ids of the teams the caller manages at this customer; [] for an agent. */
    manages?: string[];
    /** True when the caller is the effective stats reviewer of the customer or any job (#1652); false for an agent. */
    stats_reviewer?: boolean;
    /** True for a non-Manager a Manager named a reviewer of at least one guide (migration 000190); false for an agent and a Manager. */
    guide_reviewer?: boolean;
    /** True for a Manager or a person granted the Finance view at this customer (migration 000153); false for an agent. */
    finance_view?: boolean;
}
export interface CustomerAIAccess {
    customer: string;
    enforced: boolean;
    // The address AutoCoder and connector work bills; "" = the default service address.
    billing_email: string;
    // What Bayes Price adds to its cost to make the customer's price (spend
    // control PR 5): 50 makes a £10,000 cost a £15,000 price. Manager only.
    markup_pct: number;
    // The billing basis (spend control PR 6a). Manager only, on this row.
    billing_mode: BillingMode;
    // What one credit is worth in pounds; credits are price ÷ this.
    credit_value_gbp: number;
    display_unit: BillingDisplayUnit;
    // A team's headroom, as a % of its allocation, while none is typed.
    headroom_pct: number;
    // Whether a call the provider's content filter refused is charged to the
    // team's budget (migration 000167); true by default. Manager only.
    charge_filtered_calls: boolean;
    // The percentages of a team's allocation that raise a bell notice (spend
    // control PR 6b); [] = no notices. A team may override it.
    alert_thresholds: number[];
    // The EFFECTIVE hours-saved minutes per AI call, by feature key (migration
    // 000148): the defaults overlaid with this customer's override.
    minutes_saved: Record<string, number>;
    // The "UK/EEA only" setting (#1601, migration 000185): on, any model the
    // registry (goapi/pkg/aimodels) does not mark uk_eea is refused. Manager only.
    uk_eea_only?: boolean;
    // ThemeAI's standard sentiment / emotion codes switched off for this
    // customer (#1234 SKY-20, migration 000186). Manager only.
    themeai_sentiment_off?: boolean;
    themeai_emotion_off?: boolean;
    updated_by: string;
    updated_at: number;
}
// #1537 PR D — POST /ai-access/:customer/request ("Request access").
export interface AIAccessRequestResponse {
    requested: boolean;
    level: number;
    notified_admins: number;
    // True when the request was saved but the Realm admin list could not be
    // read (a licensing outage) — distinct from notified_admins: 0, which
    // means the lookup worked and genuinely found nobody.
    notify_failed?: boolean;
    requested_at: number;
}
// #1226 — team budgets. GET /admin/customers/:customer/budgets
// (goapi/pkg/server/budgets.go). Every money figure is the customer's PRICE:
// the ledger is price since spend control PR 6a. headroom_gbp,
// cost_spent_gbp, markup_pct and margin_pct are present for Managers only.
export interface TeamBudgetView {
    team_id: string;
    team_name: string;
    archived: boolean;
    // The shown budget year (annual budgets, migration 000145): the one
    // covering now, else the team's latest. start inclusive, end exclusive,
    // epoch ms; null with period_id for a team with no year.
    budget_start_at: number | null;
    budget_end_at: number | null;
    budget_state: BudgetState;
    period_id: string | null;
    allocated_gbp: number;
    opening_spend_gbp: number;
    live_spent_gbp: number;
    spent_gbp: number;
    remaining_gbp: number;
    pct: number;
    headroom_gbp?: number;
    // What the spend cost us (Manager only).
    cost_spent_gbp?: number;
    // The customer's current markup (Manager only).
    markup_pct?: number;
    // The share of the spent price that is not our cost, % (Manager only).
    margin_pct?: number;
    // The alert percentages that apply to this team (its own list, else the
    // customer's), and whether the list is the team's own (Manager only;
    // spend control PR 6d). A Realm admin's band colours read the defaults.
    alert_thresholds?: number[];
    alert_thresholds_custom?: boolean;
}
// The unit money is read in. headroom_pct and charge_filtered_calls are
// Manager figures.
export interface BudgetBillingView {
    mode: BillingMode;
    credit_value_gbp: number;
    display_unit: BillingDisplayUnit;
    headroom_pct?: number;
    charge_filtered_calls?: boolean;
}
export interface TeamBudgetsResponse {
    customer: string;
    currency: string;
    usd_to_gbp: number;
    billing: BudgetBillingView;
    teams: TeamBudgetView[];
    // The customer's "Enforce AI access levels" switch (Realm admins and
    // Managers). With it on, a team with no budget is refused AI.
    enforced: boolean;
    // The customer's current markup: what a cost entry converts at. Manager only.
    markup_pct?: number;
    // The customer's default alert percentages. Manager only.
    alert_thresholds?: number[];
    // The customer's effective hours-saved minutes per AI call, by feature
    // key. Served only to a Manager outside the client view and to a person
    // with the Finance view (migration 000153); absent for everyone else.
    minutes_saved?: Record<string, number>;
}
// PUT /admin/customers/:customer/ai-access — the billing settings dialog
// (spend control PR 6d). Each key is optional and saved on its own; the
// dialog sends only the fields that changed.
export interface BillingSettingsUpdate {
    billing_mode?: BillingMode;
    markup_pct?: number;
    credit_value_gbp?: number;
    display_unit?: BillingDisplayUnit;
    headroom_pct?: number;
    charge_filtered_calls?: boolean;
    alert_thresholds?: number[];
    // Feature key to minutes, MERGED into the customer's override; null
    // resets every feature to its default.
    minutes_saved?: Record<string, number> | null;
}
// PUT /admin/customers/:customer/budgets/:teamId — Manager only. The figures
// are the team's new totals; the server appends the difference to the ledger.
// Each figure goes ONE way (spend control PR 6a): the customer's price
// (allocation_price_gbp), our cost converted at the current markup
// (allocation_cost_gbp) or credits (allocation_credits). Two ways is a 400,
// and so is the bare allocation_gbp / headroom_gbp (our cost before 6a).
export interface TeamBudgetUpdate {
    allocation_price_gbp?: number;
    allocation_cost_gbp?: number;
    allocation_credits?: number;
    headroom_price_gbp?: number;
    headroom_cost_gbp?: number;
    headroom_credits?: number;
    note: string;
    // YYYY-MM-DD, 00:00 UTC: where a team's FIRST budget year starts. Sent
    // with an allocation only; a team that has a year refuses it.
    start_date?: string;
}
// Annual budgets PR B (goapi/pkg/server/budget_periods.go). One budget year
// of a team on GET /admin/customers/:customer/budgets/:teamId/periods. Money
// is the customer's price; headroom_gbp, headroom_typed, cost_spent_gbp,
// margin_pct and note are present for Managers only.
export interface BudgetPeriodView {
    id: string;
    // Epoch ms; end_at exclusive.
    start_at: number;
    end_at: number;
    // This year's own state: before it starts, while it covers now, after.
    state: 'scheduled' | 'active' | 'ended';
    // current: the year covering now. latest: the year whose start can move.
    current: boolean;
    latest: boolean;
    allocated_gbp: number;
    spent_gbp: number;
    remaining_gbp: number;
    pct: number;
    headroom_gbp?: number;
    // The headroom is a typed figure, not the customer's percentage.
    headroom_typed?: boolean;
    cost_spent_gbp?: number;
    margin_pct?: number;
    note?: string;
}
// GET .../budgets/:teamId/periods: every year, newest first.
export interface BudgetPeriodsResponse {
    team_id: string;
    team_name: string;
    periods: BudgetPeriodView[];
}
// POST .../budgets/:teamId/periods: start the next year at start_date with
// its own allocation (one way, as on PUT) and optionally a headroom.
export type StartBudgetYearRequest = TeamBudgetUpdate & { start_date: string };
// The POST's answer: the new year, and whether it cut the latest year short.
export type StartBudgetYearResponse = BudgetPeriodView & { truncated_previous: boolean };
// PATCH .../budgets/:teamId/periods/:periodId: move the latest year's start.
export interface MoveBudgetYearRequest {
    start_date: string;
    note: string;
}
// GET .../budgets/:teamId/spend?from=&to= (Manager only): the team's charge
// in [from, to), the customer's price, and our cost.
export interface BudgetSpendPreview {
    from: number;
    to: number;
    charged_gbp: number;
    cost_gbp: number;
}
// GET /admin/customers/:customer/budgets/usage?month=YYYY-MM&group_by=team|user|detail
// A row with no user_id is the folded line: addresses the caller may not see.
export interface TeamUsageRow {
    date?: string;
    team_id: string;
    team_name: string;
    user_id?: string;
    label: string;
    feature_key?: string;
    model?: string;
    job?: string;
    request_count: number;
    total_tokens: number;
    /** What the rows charged the team's budget: the customer's price, for everyone (spend control PR 6a). */
    charged_gbp: number;
    /** Our cost, on a Manager's rows only: anyone else's rows have no such key. */
    cost_gbp?: number;
    /** Part of the cost is a model the rate card does not price, charged at the dearest rate. */
    unpriced?: boolean;
    /** "content_filtered" on a detail row of calls the provider's content filter refused (migration 000167); absent otherwise. */
    outcome?: 'content_filtered';
}
export interface TeamUsageResponse {
    month: string;
    from: number;
    to: number;
    group_by: 'team' | 'user' | 'detail';
    currency: string;
    usd_to_gbp: number;
    rows: TeamUsageRow[];
    // The customer's current markup, what new usage is charged at. Manager only.
    markup_pct?: number;
}

// Spend control PR 6c (migration 000144): fixed mode's price list, charges
// and the margin report (goapi/pkg/server/billing.go, pkg/types/billing.go).
// Per-action kinds are booked as one team charge; "call:<feature_key>" kinds
// are priced on the usage row.
export type PriceItemKindName =
    | 'agent_turn' | 'tables_pane_turn' | 'guided_turn' | 'themeai_run' | 'themeai_test' | 'autocoder_record' | 'storyboard'
    | `call:${string}`;
export interface PriceItemKind {
    kind: PriceItemKindName;
    label: string;
    unit_label: string;
    per_action: boolean;
}
// One row of a customer's price list. A current row has retired_at null; a
// price change retires it and writes a new one.
export interface BillingPriceItem {
    id: string;
    customer: string;
    kind: PriceItemKindName;
    unit_label: string;
    unit_price_credits: number;
    effective_from: number;
    retired_at: number | null;
    note: string;
    created_by: string;
    created_at: number;
}
// GET/PUT /admin/customers/:customer/billing/price-list — Manager only.
export interface PriceListResponse {
    customer: string;
    billing: BudgetBillingView;
    kinds: PriceItemKind[];
    items: BillingPriceItem[];
    // Retired rows, newest first, with ?history=1.
    history?: BillingPriceItem[];
}
// The PUT body: each kind named is set (or removed); a kind not named keeps its price.
export interface PriceListUpdate {
    items: { kind: PriceItemKindName; unit_price_credits?: number; remove?: boolean; note?: string }[];
}
// GET /admin/customers/:customer/billing/margin?month=YYYY-MM — Manager only.
export interface MarginLine {
    kind: string;
    label: string;
    count: number;
    charged_gbp: number;
    cost_gbp: number;
    margin_pct: number;
    flagged: boolean;
}
export interface MarginReport {
    customer: string;
    month: string;
    from: number;
    to: number;
    floor_pct: number;
    lines: MarginLine[];
    charged_gbp: number;
    cost_gbp: number;
    margin_pct: number;
    cost_source: string;
}
// GET /admin/customers/:customer/budgets/charges?month=&team_id= — Realm
// admin or Manager. A charge is the list price it was booked at, in credits
// and pounds; never a cost or a margin.
export interface TeamChargeView {
    id: string;
    date: string;
    team_id: string;
    team_name: string;
    // Absent on a folded line (an address the caller may not see).
    user_id?: string;
    label: string;
    kind: string;
    what: string;
    unit_label: string;
    action_ref: string;
    job?: string;
    quantity: number;
    unit_price_credits: number;
    credit_value_gbp: number;
    charged_gbp: number;
    credits: number;
    note?: string;
    created_at: number;
}
export interface ListPriceView {
    kind: string;
    label: string;
    unit_label: string;
    unit_price_credits: number;
}
export interface TeamChargesResponse {
    month: string;
    from: number;
    to: number;
    billing: BudgetBillingView;
    prices: ListPriceView[];
    charges: TeamChargeView[];
}

// Billing simulator (design/2026-10-06-billing-simulator.md). Hand-written
// mirror of the json tags in goapi/pkg/billingsim/settings.go and report.go.
// POST /admin/customers/:customer/billing/simulate and
// GET  /admin/customers/:customer/billing/simulate/defaults, Manager only.
// Everything is fictional and nothing is saved.
export interface SimBilling {
    mode: BillingMode;
    markup_pct: number;
    credit_value_gbp: number;
    display_unit: BillingDisplayUnit;
    headroom_pct: number;
    // The customer's switch (migration 000167), carried through; the
    // simulator does not model content-filtered calls.
    charge_filtered_calls?: boolean;
}
export interface SimPriceItemSetting {
    kind: string;
    unit_price_credits: number;
}
// allocation_gbp is required (0 is legal). headroom_gbp null is "use the
// customer's headroom %", 0 is a typed £0. thresholds null is "the
// customer's", [] is "no notices".
export interface SimTeamSetting {
    id: string;
    allocation_gbp: number;
    headroom_gbp: number | null;
    thresholds: number[] | null;
}
export interface SimSettings {
    billing: SimBilling;
    // null is the product default (50, 75, 90, 100); [] is no notices.
    thresholds: number[] | null;
    price_list: SimPriceItemSetting[];
    teams: SimTeamSetting[];
}
export interface SimRequest {
    seed: number;
    settings: SimSettings;
    compare: SimSettings | null;
    detail_team: string;
}
export interface SimPerson {
    email: string;
    name: string;
    hidden?: boolean;
}
export interface SimPeriod {
    from: number;
    to: number;
    months: string[];
}
export interface SimFinalBalance {
    allocated_gbp: number;
    opening_spend_gbp: number;
    headroom_gbp: number;
    live_spent_gbp: number;
    spent_gbp: number;
    remaining_gbp: number;
    pct: number;
    start_at: number | null;
    cost_spent_gbp: number;
    margin_pct: number;
}
export interface SimDayPoint {
    date: string;
    spent_gbp: number;
    cost_gbp: number;
    refused_gbp: number;
    calls: number;
}
export type SimMarkerKind = 'alert' | 'headroom_alert' | 'batch_stop' | 'interactive_stop';
export interface SimMarker {
    date: string;
    at: number;
    kind: SimMarkerKind;
    // The alert's percentage (101 for the headroom notice); absent on a stop.
    threshold?: number;
}
export interface SimRefusal {
    at: number;
    date: string;
    email: string;
    kind: string;
    feature_key: string;
    ref: string;
    feature: string;
    rule: 'batch' | 'interactive' | string;
    reason: string;
    quantity: number;
    value_gbp: number;
    held?: boolean;
    calls_done?: number;
    calls_demanded?: number;
}
export interface SimBooking {
    at: number;
    date: string;
    email: string;
    kind: string;
    ref: string;
    charged_gbp: number;
}
export interface SimAlert {
    at: number;
    date: string;
    thresholds: number[];
    highest: number;
    // The team's spend when the alert was sent, as the bell's sentence quotes it.
    spent_gbp: number;
}
export interface SimKindTotal {
    kind: string;
    label: string;
    count: number;
    charged_gbp: number;
    cost_gbp: number;
}
// The detail rows and charges carry the fields of TeamUsageRow and
// TeamChargeView, so rowsFromUsage and rowsFromCharges read them.
export interface SimUsageDetailRow {
    date: string;
    team_id: string;
    team_name: string;
    user_id: string;
    label: string;
    feature_key: string;
    model: string;
    request_count: number;
    total_tokens: number;
    charged_gbp: number;
    cost_gbp: number;
}
export interface SimChargeDetailRow {
    id: string;
    date: string;
    team_id: string;
    team_name: string;
    user_id: string;
    label: string;
    kind: string;
    what: string;
    unit_label: string;
    action_ref: string;
    quantity: number;
    unit_price_credits: number;
    credit_value_gbp: number;
    charged_gbp: number;
    credits: number;
    created_at: number;
}
export interface SimTeamReport {
    id: string;
    name: string;
    scenario: string;
    people: SimPerson[];
    thresholds: number[];
    final: SimFinalBalance;
    daily: SimDayPoint[];
    markers: SimMarker[];
    refused: SimRefusal[];
    refused_truncated: number;
    refused_count: number;
    refused_value_gbp: number;
    held_batches: number;
    cut_turns: number;
    booked_past_stop: SimBooking[];
    alerts: SimAlert[];
    by_kind: SimKindTotal[];
    // Filled for the one team named in detail_team.
    rows?: SimUsageDetailRow[];
    charges?: SimChargeDetailRow[];
}
export interface SimMonthTotals {
    month: string;
    charged_gbp: number;
    cost_gbp: number;
    margin_pct: number;
    refused_count: number;
    refused_value_gbp: number;
}
export interface SimTotals {
    charged_gbp: number;
    cost_gbp: number;
    margin_pct: number;
    credits: number;
    refused_count: number;
    refused_value_gbp: number;
    held_batches: number;
    cut_turns: number;
    alerts_sent: number;
    bell_rows: number;
    months: SimMonthTotals[];
}
export interface SimReport {
    fictional: boolean;
    seed: number;
    period: SimPeriod;
    settings: SimSettings;
    teams: SimTeamReport[];
    totals: SimTotals;
    margin: MarginReport | null;
    compare?: SimReport;
}
// Team managers (migration 000146, goapi/pkg/types/budget_teams.go). name is
// empty when licensing holds only the email; appointed_by is blanked for a
// caller who may not see that address.
export interface TeamManagerView {
    email: string;
    name: string;
    appointed_by: string;
    appointed_at: number;
}
// A team's budget on GET /teams (goapi/pkg/server/teams.go teamCardBudget):
// the customer's price in pounds, the bell's figures, for every caller. Never
// cost, markup or margin. Credits = pounds ÷ credit_value_gbp.
export interface TeamCardBudget {
    allocated_gbp: number;
    spent_gbp: number;
    remaining_gbp: number;
    pct: number;
    display_unit: BillingDisplayUnit;
    credit_value_gbp: number;
    // The team's budget year now (migration 000145); the figures are of the
    // year covering now, else its latest.
    budget_state?: BudgetState;
    // That year's window, epoch ms, ends_at exclusive.
    starts_at?: number | null;
    ends_at?: number | null;
}
// One rate per 1M units: list USD, our £ cost, and credits at the customer's
// markup and credit value (GET /admin/customers/:customer/billing/rates).
export interface RateFigure {
    usd: number;
    cost_gbp: number;
    credits: number;
}
export interface ModelRateRow {
    model: string;
    provider: string;
    // What the rates count: "tokens", "audio seconds" or "characters".
    unit: string;
    // The row carries the Bedrock EU inference profile's uplift.
    bedrock_eu: boolean;
    used_recently: boolean;
    input: RateFigure;
    output: RateFigure;
    // Omitted for a row with no cache (audio, embeddings).
    cache_read?: RateFigure;
    cache_write?: RateFigure;
}
// The metered conversion inputs and the rate card in credits. Manager only.
export interface BillingRatesResponse {
    customer: string;
    usd_to_gbp: number;
    markup_pct: number;
    credit_value_gbp: number;
    billing_mode: BillingMode;
    bedrock_eu_uplift: number;
    used_window_days: number;
    models: ModelRateRow[];
}

// The reviewer a customer names on Admin → Context → Stats review. Empty
// fields mean none is set.
export interface AnalysisReviewer {
    name: string;
    contact: string;
    team: string;
}
// One advanced-analysis notice (POST /session/analysis-flags, #1653). The
// `line` is composed by the server; the card prints it as given.
export interface AnalysisFlag {
    id: string;
    method: string;
    method_label: string;
    summary: string;
    reviewer: AnalysisReviewer;
    line: string;
    // Unix ms.
    created_at: number;
}
// The `analysis_flagged` plugin event: the flag body, plus the harness's tool call id.
export interface AnalysisFlaggedEvent extends AnalysisFlag {
    toolCallId?: string;
}
// One person granted the Finance view at a customer (migration 000153,
// GET /admin/customers/:customer/finance-viewers). Manager only.
export interface FinanceViewer {
    email: string;
    granted_by: string;
    // Unix ms.
    granted_at: number;
}
// POST /tables/:customer/:job/remove (#1795): full .cbt blob paths and full
// folder prefixes (no trailing slash). A folder means every table under it.
export interface RemoveTablesRequest {
    paths: string[];
    folders: string[];
    dryRun: boolean;
}
export interface RemoveTablesFailure {
    path: string;
    error: string;
}
export interface RemoveTablesReference {
    path: string;
    by: string;
    kind: 'dashboard' | 'multi_table' | 'analysis' | 'chat_output';
}
export interface RemoveTablesResponse {
    dryRun: boolean;
    count: number;
    deleted: string[];
    failed: RemoveTablesFailure[];
    folders: string[];
    referenced: RemoveTablesReference[];
}
// POST /tables/:customer/:job/user-folder/rename (#1795): renames the last
// segment of a My Tables folder and moves the tables inside it.
export interface RenameUserFolderRequest {
    folder: string;
    newName: string;
    dryRun: boolean;
}
export interface RenameUserFolderResponse {
    dryRun: boolean;
    count: number;
    from: string;
    to: string;
    referenced: RemoveTablesReference[];
    failed: RemoveTablesFailure[];
}
// POST /tables/:customer/:job/user-table/move (#1795 follow-up): moves one
// My Tables table (its blob, its user.toc entry and its metadata) into
// another My Tables folder, and renames it when newName is set. destFolder
// is relative to Tables/User/<email>; '' is the top level. A clash or a
// table used elsewhere is a 409 carrying {error, referenced?}; a destination
// folder that does not exist, or no change, is a 400.
export interface MoveUserTableRequest {
    path: string;
    destFolder: string;
    newName?: string;
    dryRun?: boolean;
}
export interface MoveUserTableResponse {
    from: string;
    to: string;
    dryRun: boolean;
    referenced: RemoveTablesReference[];
    // Non-empty only when the copy landed but the old blob could not be
    // deleted: that old copy shows at the top of My Tables.
    failed?: RemoveTablesFailure[];
}

// ---- Bar chart settings (#1808) ----
// Declaration merges onto ChartAxisDesign, ChartDesign and
// TableGraphWidgetData declared earlier in this file. Mirrors the Go types in
// goapi/pkg/types/types.go. See ../utils/applyChartDesign.ts (balanced axis,
// colour rules) and components/platinum-graphs/utils/chartSort.ts (sort).

/** Bar order on a bar-family chart. Absent keeps each chart type's old order. */
export type ChartSortOrder = 'table' | 'desc' | 'asc';
/** What each bar is labelled with: row label, innermost side-group heading + row label, or the heading only. */
export type ChartCategoryLabelMode = 'row' | 'group_row' | 'group';

export interface ChartAxisDesign {
    /** "Balanced around 0" (#1808): the value axis runs -limit..+limit, sized on the plotted bars at every draw. Stored on y_axis; overrides min/max. */
    balanced_zero?: boolean;
}
/**
 * Value-based bar colours (#1808). Rules are the table widget's rule model —
 * first match wins, the colour is `background_color` — with thresholds in
 * display units (5 means 5% on a percentage chart). `default_color` colours
 * the bars no rule matches. Rules and the default win over color_overrides.
 */
export interface ChartBarColorsDesign {
    rules: TableConditionalFormatRule[];
    default_color?: string;
}
export interface ChartDesign {
    bar_colors?: ChartBarColorsDesign;
}
export interface TableGraphWidgetData {
    /** Bar order (#1808). Absent = the chart type's old order: bar and column highest first, clustered and stacked in table order. */
    sort_order?: ChartSortOrder;
    /** Bar label mode (#1808). Absent = 'row'. */
    category_label?: ChartCategoryLabelMode;
}

/**
 * A Manager's note on one System context feature (goapi types.FeatureContext,
 * table feature_context, 13 Oct 2026). Laid over the shipped text of the
 * feature registry (help/features) when read. job is '' for a customer-level
 * note, the only kind written so far.
 */
export interface FeatureContextRecord {
    id: string;
    customer: string;
    job: string;
    section_key: string;
    feature_key: string;
    context: string;
    updated_by: string;
    created_at: number;
    updated_at: number;
}

/**
 * A customer's starter questions for one app section (goapi
 * types.HelpStarters, table help_starters, migration 000160, 19 Oct 2026).
 * Routes: GET /help/:customer/starters, PUT and DELETE
 * /help/:customer/starters/:section (Manager only). Replaces the section's
 * shipped `starters` wholesale; an empty list means no pills. job is '' for
 * a customer-level list, the only kind written so far. PUT takes an optional
 * `intro` beside `questions`: absent keeps the stored line, '' clears it.
 */
export interface HelpStartersRecord {
    id: string;
    customer: string;
    job: string;
    section_key: string;
    questions: string[];
    // The section's opening line (migration 000161); '' = the shipped one.
    intro: string;
    updated_by: string;
    created_at: number;
    updated_at: number;
}

// One of a customer's own email domains (migration 000156,
// GET/PUT /admin/customers/:customer/email-domains). Manager only. When the
// list is set, a non-Manager sees a colleague's work only when the owner's
// email domain is on it; exact match, lower-cased.
export interface CustomerEmailDomain {
    domain: string;
    created_by: string;
    // Unix ms.
    created_at: number;
}
// The body of both email-domain routes. PUT sends {domains: string[]} and
// replaces the list ([] clears it).
export interface CustomerEmailDomainsResponse {
    domains: CustomerEmailDomain[];
}

// Junk check (#1891). A durable record on the task, one per data revision:
// GET/POST/DELETE /themeai/:customer/:job/tasks/:taskId/screening. A free rules
// pass then a small model flag answers that are not answers; the user keeps
// them, drops them or codes them as code 99 "Junk / no answer".
export type ThemeAIJunkDecision = '' | 'keep' | 'drop' | 'code';

export type ThemeAIScreeningStatus = 'pending' | 'running' | 'completed' | 'failed';

export type ThemeAIJunkCategory =
    | 'empty'
    | 'no_letters'
    | 'keyboard_mash'
    | 'stock_phrase'
    | 'copied_text'
    | 'off_topic'
    | 'other';

export interface ThemeAIScreening {
    id: string;
    task_id: string;
    data_revision: number;
    status: ThemeAIScreeningStatus;
    phase?: string;
    error?: string;
    // What the user chose for the flagged answers; '' until they choose.
    decision: ThemeAIJunkDecision;
    response_count: number;
    rule_flagged_count: number;
    model_candidate_count: number;
    // Flagged answers, before the user's per-answer Keep overrides.
    flagged_count: number;
    // Flagged answers the user marked Keep.
    kept_count: number;
    // Answers the model pass could not check (a chunk failed or omitted them).
    unchecked_count: number;
    token_actual: number;
    // Omitted for a non-Manager, and when 0. Never show it to a non-Manager.
    cost?: number;
    created_at: number;
    completed_at?: number;
    // The older completed check whose decision runs still apply, present while
    // this one is running, failed or cancelled. Absent when this is the one in use.
    applied?: ThemeAIScreening;
    // Transient: progress of the model pass, and the flagged answers by category.
    requests_total?: number;
    requests_done?: number;
    by_category?: {[key: string]: number};
    // True when the check was made on the task's current data.
    current?: boolean;
    // The personal data finding (#494), from the same check. False for a
    // check made before the finding existed: it never looked. Optional: a
    // server from before #494 sends none of them.
    personal_data_checked?: boolean;
    personal_data_decision?: ThemeAIPersonalDataDecision;
    personal_data_count?: number;
    personal_data_kept_count?: number;
    personal_data_by_category?: {[key: string]: number};
}

export interface ThemeAIScreeningRecordRow {
    record_id: string;
    interview_id: string;
    source_text: string;
    category: ThemeAIJunkCategory;
    reason: string;
    source: 'rule' | 'model';
    // A rule that is certain (empty, random characters); the model never overturns it.
    certain: boolean;
    // The user chose to keep this answer whatever the decision.
    kept: boolean;
}

// GET .../screening/records?category=&limit=&offset=
export interface ThemeAIScreeningRecordsPage {
    total: number;
    records: ThemeAIScreeningRecordRow[];
}

// Personal data flag (#494): the junk check's second finding. Flag only: an
// answer's text is never changed. 'code' adds code 98 "Contains personal data"
// beside the answer's themes.
export type ThemeAIPersonalDataDecision = '' | 'keep' | 'code';

export type ThemeAIPersonalDataCategory =
    | 'email'
    | 'phone'
    | 'card_number'
    | 'ni_number'
    | 'ip_address'
    | 'postcode'
    | 'name'
    | 'address'
    | 'id_number'
    | 'other';

export interface ThemeAIPersonalDataRecordRow {
    record_id: string;
    interview_id: string;
    source_text: string;
    // The kinds of data found, never the data itself.
    categories: ThemeAIPersonalDataCategory[];
    source: 'rule' | 'model';
    certain: boolean;
    kept: boolean;
}

// GET .../screening/personal-data?category=&limit=&offset=
export interface ThemeAIPersonalDataRecordsPage {
    total: number;
    records: ThemeAIPersonalDataRecordRow[];
}

// POST .../screening/estimate: the check's own cost, priced like a run's.
export interface ThemeAIScreeningEstimate {
    response_count: number;
    rule_flagged: number;
    // Answers the free rules found personal data in.
    rule_personal_data?: number;
    model_candidates: number;
    estimated_tokens: number;
    estimated_cost: number;
    currency: 'GBP';
    remaining_budget: number | null;
    display_unit: BillingDisplayUnit;
    credit_value_gbp: number;
    units?: number;
    unit_label?: string;
}

// #1234 — the AI models in use page. GET /admin/customers/:customer/ai-models
// (goapi/pkg/server/ai_models.go); each row is goapi/pkg/aimodels/models.json.
export type AIModelResidency = 'uk_eea' | 'global' | 'non_eu';
export interface AIModel {
    id: string;
    kind: 'lane' | 'agent' | 'embedding' | 'speech_to_text' | 'realtime' | 'text_to_speech';
    lane?: string;
    agent_provider?: string;
    deployment: string;
    model: string;
    purpose: string;
    provider: string;
    account: string;
    region: string;
    deployment_type: string;
    residency: AIModelResidency;
    model_card_url: string;
    date_added: string;
    verified: string;
    // Under this server's config, and whether the customer's UK/EEA only
    // setting refuses it.
    effective_residency: AIModelResidency;
    refused: boolean;
}
// One line of the customer's Changes list; dates are YYYY-MM-DD and
// customer_told_on is "" until someone has told the customer.
export interface AIModelChange {
    id: string;
    customer: string;
    changed_on: string;
    what: string;
    customer_told_on: string;
    created_by: string;
    created_at: number;
    updated_by: string;
    updated_at: number;
}
export interface AIModelsResponse {
    customer: string;
    uk_eea_only: boolean;
    themeai_sentiment_off: boolean;
    themeai_emotion_off: boolean;
    models: AIModel[];
    changes: AIModelChange[];
    can_edit: boolean;
}
// Guided conversations (28 Oct 2026) — hand-written; mirrors
// goapi/pkg/types/guided.go. A Manager writes a guide (goal plus agenda
// points) and invites people; each person's response is worked through by a
// `guided` agent chat. Routes: /api/v1/guided/:customer/... All times are
// epoch ms; nullable fields are null, never omitted.
export type GuideStatus = 'draft' | 'open' | 'closed';
export type GuideResponseStatus = 'invited' | 'in_progress' | 'finished' | 'finished_early' | 'withdrawn';
export type GuidePointStatus = 'pending' | 'active' | 'covered' | 'skipped' | 'declined';
export type GuideNoteType =
    | 'fact' | 'definition' | 'metric' | 'procedure' | 'decision_rule'
    | 'pain_point' | 'source' | 'tool_request' | 'example';
export type GuideNoteCuration = 'none' | 'context' | 'skill' | 'tool_request' | 'discard';
export interface GuidePoint {
    id: string;
    title: string;
    question: string;
    goal: string;
    covered_when: string[];
}
export interface GuideCounts {
    invited: number;
    in_progress: number;
    finished: number;
}
export interface Guide {
    id: string;
    customer: string;
    title: string;
    goal: string;
    // Shown to the person before they start.
    intro: string;
    // Who will read the answers, shown to the person.
    readers_note: string;
    jobs: string[];
    status: GuideStatus;
    current_version: number;
    // The points of current_version.
    points: GuidePoint[];
    created_by: string;
    created_at: number;
    updated_at: number;
    // On the list and get routes only.
    counts?: GuideCounts;
}
// POST /guides and PUT /guides/:guideId. PUT also names current_version and status.
export interface GuideBody {
    title: string;
    goal: string;
    intro: string;
    readers_note: string;
    jobs: string[];
    points: GuidePoint[];
    current_version?: number;
    status?: GuideStatus;
}
export interface GuideResponse {
    // The URL id: /guided/<customer>/<id>.
    id: string;
    guide_id: string;
    customer: string;
    email: string;
    // Pinned at start; null until then.
    guide_version: number | null;
    session_id: string | null;
    status: GuideResponseStatus;
    invited_by: string;
    invited_at: number;
    started_at: number | null;
    finished_at: number | null;
    last_active_at: number | null;
}
export interface GuidePointState {
    point_id: string;
    status: GuidePointStatus;
    confidence: number | null;
    missing: string[];
    set_by: 'agent' | 'person';
    updated_at: number;
}
export interface GuideNote {
    id: string;
    response_id: string;
    point_id: string | null;
    type: GuideNoteType;
    title: string;
    body: string;
    source_files: string[];
    origin: 'agent' | 'person';
    person_edited_at: number | null;
    version: number;
    curation: GuideNoteCuration;
    curation_note: string;
    created_at: number;
    updated_at: number;
}
// A note as its person and a guide's reviewers read it: without the
// Manager's curation (goapi GuideNoteView).
export type GuideNoteView = Omit<GuideNote, 'curation' | 'curation_note'>;
// A reviewer of a guide (migration 000190): reads its progress and notes,
// never the chat, the curation or the export. Manager-only routes
// GET/POST /guides/:guideId/reviewers, DELETE .../reviewers/:email.
export interface GuideReviewer {
    guide_id: string;
    email: string;
    // Their name when they were added.
    name: string;
    added_by: string;
    added_at: number;
}
// A reviewer as the respondent sees them.
export interface GuideReader {
    name: string;
    email: string;
}
export interface GuideReviewerResult {
    email: string;
    result: 'added' | 'existing' | 'refused';
    reason: string;
}
// GET /responses/:id: the response, its pinned version's points (else the
// current ones), the point states, the live notes (without curation) and the
// guide's reviewers.
export interface GuideResponseView {
    response: GuideResponse;
    guide: Guide;
    points: GuidePoint[];
    states: GuidePointState[];
    notes: GuideNoteView[];
    // Who besides the Managers reads the notes.
    reviewers: GuideReader[];
    // The caller is the respondent and the response is open.
    can_edit: boolean;
    // The respondent may still correct the notes: the guide is open and the
    // conversation started and was not withdrawn (finished included).
    can_edit_notes: boolean;
}
export interface GuideInviteResult {
    email: string;
    result: 'created' | 'existing' | 'refused';
    reason: string;
    response_id: string | null;
    // The path /guided/<customer>/<response_id>.
    url: string | null;
}
// One row of GET /guides/:guideId/responses. A reviewer's rows carry no
// session_id and no curation; a Manager's carry both.
export interface GuideResponseDetail {
    response: Omit<GuideResponse, 'session_id'> & { session_id?: string | null };
    states: GuidePointState[];
    notes: Array<GuideNoteView & Partial<Pick<GuideNote, 'curation' | 'curation_note'>>>;
}
// One row of GET /mine.
export interface GuideMineItem {
    response: GuideResponse;
    guide_title: string;
    // Only an open guide's conversation can go on (History's resume box).
    guide_status: GuideStatus;
}
// One version of an analysis profile (goapi AnalysisProfileVersion): the short
// markdown that says how a job's data is built. Published rows carry a
// version number; a proposal is a row an agent made, or a person typed, for a
// Manager to decide.
export type AnalysisProfileStatus = 'published' | 'proposed' | 'accepted' | 'declined' | 'withdrawn';
export interface AnalysisProfileVersion {
    id: string;
    customer: string;
    // "" is the customer-level profile.
    job: string;
    // Set on published rows.
    version: number | null;
    status: AnalysisProfileStatus;
    base_version: number;
    body: string;
    summary: string;
    author_email: string;
    // 'person': typed on the card section by section.
    source: 'agent' | 'restore' | 'person';
    session_id?: string;
    published_from?: string;
    decided_by?: string;
    decided_at?: number;
    decision_note?: string;
    // Unix ms.
    created_at: number;
}
// One profile version a model call outside a chat read (#2014). job "" is
// the customer level; stale: the job was re-indexed after it was published.
export interface AnalysisProfileRef {
    job: string;
    label: string;
    version: number;
    // Unix ms.
    published_at: number;
    stale?: boolean;
}
// GET /analysis-profile/:customer?job=<job>.
export interface AnalysisProfileResponse {
    current: AnalysisProfileVersion | null;
    // Published versions, newest first.
    versions: AnalysisProfileVersion[];
    // Proposed rows, newest first.
    proposals: AnalysisProfileVersion[];
    // True for a Manager.
    can_publish: boolean;
    // Unix ms: the job's data was re-indexed after the current version was
    // published, so it may be stale (#2001). Absent otherwise.
    reindexed_at?: number;
}
// POST /analysis-profile/:customer: what a person typed on the card. A
// Manager's save publishes; anyone else's is a proposal.
export interface AnalysisProfileSaveResult {
    result: 'published' | 'proposed';
    version: AnalysisProfileVersion;
}
